import { AppConfiguration } from '../../app-configuration/app-configuration.js';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import { KatapultPageElement, html } from '../../mixins/katapult-page-element.js';
import { html as litHtml, render } from 'lit';
import { timeOut } from '@polymer/polymer/lib/utils/async.js';
import { Debouncer } from '@polymer/polymer/lib/utils/debounce.js';
import * as Comlink from 'comlink/dist/esm/comlink';
import pluralize from 'pluralize-esm';
import '@polymer/paper-styles/shadow.js';
import '@polymer/paper-dialog/paper-dialog.js';
import '@polymer/paper-toast/paper-toast.js';
import '@polymer/paper-dialog-scrollable/paper-dialog-scrollable.js';
import '@polymer/paper-menu-button/paper-menu-button.js';
import '@polymer/paper-input/paper-input.js';
import '@polymer/paper-checkbox/paper-checkbox.js';
import '@polymer/iron-list/iron-list.js';
import '@polymer/iron-collapse/iron-collapse.js';
import '@polymer/iron-icon/iron-icon.js';
import '@polymer/iron-icons/iron-icons.js';
import '@polymer/iron-icons/av-icons.js';
import '@polymer/iron-icons/hardware-icons.js';
import '@polymer/iron-icons/image-icons.js';
import '@polymer/iron-icons/social-icons.js';
import '@polymer/iron-icons/communication-icons.js';
import '@polymer/iron-icons/editor-icons.js';
import '@polymer/neon-animation/neon-animation.js';
import '@polymer/iron-collapse/iron-collapse.js';
import '@katapult/pmp-simple-date-input/pmp-simple-date-input.js';
import '@polymer/paper-tooltip/paper-tooltip.js';
import '@polymer/paper-item/paper-icon-item.js';
import 'iron-a11y-keys/iron-a11y-keys.js';
import '@katapult/s-circle-progress/s-circle-progress.js';
import '../katapult-auth/katapult-auth.js';
import '../pole-application-sign-up-form/pole-application-sign-up-form.js';
import '../katapult-maps-desktop/katapult-tool-panel.js';
import '../paper-table/paper-table.js';
import '../bind-path/bind-path.js';
import '../login-chip/login-chip.js';
import '../user-chip/user-chip.js';
import '../highlight-text/highlight-text.js';
import '../input-element/input-element.js';
import '../katapult-firebase-worker/katapult-firebase-worker.js';
import '../katapult-toolbar/katapult-toolbar.js';
import '../katapult-drop-down/katapult-multi-drop-down.js';
import '../style-modules/paper-dialog-style.js';
import '../katapult-elements/katapult-button.js';
import '../katapult-elements/katapult-icon.js';
import '../katapult-dialog-legacy/katapult-dialog-legacy';
import './app-filter-input.js';
import '../style-modules/paper-tooltip-style.js';
import '../style-modules/paper-menu-button-style.js';
import '../style-modules/flex.js';
import '../pole-application/pole-application-style.js';
import '../app-timeline-editor/app-timeline-editor.js';
import '../../js/open-source/zipjs/zip.js';
import '../../js/open-source/zipjs/zip-ext.js';
import { Download } from '../../modules/Download.js';
import { ToArray } from '../../modules/ToArray.js';
import { createWorkflowJob } from '../../modules/katapult-workflows/WorkflowJobs.js';
import { NotifyResizable } from '../../modules/NotifyResizable.js';
import { Path } from '../../modules/Path.js';
import { FormatDate } from '../../modules/Date.js';
import { SnakeCase } from '../../modules/SnakeCase.js';
import { AppExport } from '../../modules/AppExport.js';
import { UpdateJobPermissions } from '../../modules/UpdateJobPermissions.js';
import { CamelCase } from '../../modules/CamelCase.js';
import { DeepEqual } from '../../modules/DeepEqual.js';
import { KatapultDialog } from '../katapult-elements/katapult-dialog.js';
import { addFlagListener, removeFlagListener } from '../../modules/FeatureFlags.js';
import { DateTime } from 'luxon';
import { getActiveTimelineStageProgress, getTimelineProgress, calcComputedOverviewAttribute } from '../../modules/PoleApplication.js';
import { checkIsDevelopmentOrigin } from '../../modules/CheckOrigin.js';
import { Parallel } from '../../modules/Parallel.js';
import '@shoelace-style/shoelace/dist/components/spinner/spinner.js';
import '@shoelace-style/shoelace/dist/components/dropdown/dropdown.js';
import '@shoelace-style/shoelace/dist/components/button/button.js';
import '@shoelace-style/shoelace/dist/components/menu/menu.js';
import '@shoelace-style/shoelace/dist/components/menu-item/menu-item.js';
import '@shoelace-style/shoelace/dist/components/divider/divider.js';
import '@shoelace-style/shoelace/dist/components/badge/badge.js';
import '@shoelace-style/shoelace/dist/components/tooltip/tooltip.js';
import '@shoelace-style/shoelace/dist/components/option/option.js';
import { getColumnLabel, getColumnValue } from './OverviewColumns.js';
import './overview-actions-button.js';
import { adoptStyles } from 'lit';
import lightTheme from '../../themes/light.styles.js';
import { config } from '../../app-configuration/config.js';
import { ListenToUserRole } from '../../modules/Roles.js';
import SlProgressBar from '@shoelace-style/shoelace/dist/components/progress-bar/progress-bar.js';
import '@shoelace-style/shoelace/dist/components/alert/alert.js';
import { KatapultJob } from '../../modules/katapult-job/KatapultJob.js';
import { KatapultModel } from '../../modules/katapult-model/KatapultModel.js';

/*global k, Polymer, firebase */

const DEFAULT_OVERVIEW_ATTRIBUTES = {
  default_attribute: {
    attribute: 'job_name',
    order: 0,
    top_level: true
  }
};
class PoleApplicationOverview extends KatapultPageElement {
  static get template() {
    return html`
      <style include="pole-application-style paper-tooltip-style paper-menu-button-style flex">
        :host {
          height: 100%;
          font-family: Roboto;
        }
        [hidden] {
          display: none !important;
        }
        [invisible] {
          opacity: 0;
        }
        #header {
          position: relative;
          height: 64px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 8px;
          box-sizing: border-box;
          background-color: var(--primary-color);
          flex-shrink: 0;
          @apply(--shadow-elevation-2dp);
        }
        app-filter-input[slot='center'] {
          margin-right: 0;
        }
        /* This is for stacking the total draft/job when the screen is small */
        @media (max-width: 1480px) {
          app-filter-input[slot='center'] {
            margin-right: 104px;
          }
        }
        #logo {
          height: 100%;
        }
        katapult-button:not([iconOnly]) {
          min-width: 75px;
        }
        paper-table, iron-list {
          flex-grow: 1;
          min-height: 0;
        }
        #appList {
          overflow-y: scroll;
        }
        .appRow {
          background-color: var(--sl-color-neutral-0);
        }
        .appRow:nth-child(even) {
          background-color: var(--sl-color-neutral-100);
        }
        .appRow:hover {
          background-color: var(--sl-color-neutral-200);
        }
        /* Display the action button dropdown over the other app rows */
        .appRow:has(overview-actions-button[dropdown-open]) {
          z-index: 1;
          background-color: var(--sl-color-neutral-200);
        }
        .appRow:not(:last-of-type) {
          border-bottom: 1px solid var(--sl-color-neutral-100);
        }
        paper-table-scroll > paper-row:not(:last-of-type) {
          border-bottom: 1px solid var(--sl-color-neutral-300);
        }
        paper-cell:first-of-type {
          max-width: 48px;
          justify-content: center;
        }
        paper-cell[clickable]:hover {
          cursor: pointer;
        }
        paper-cell.button {
          max-width: 64px;
          padding: 0;
          justify-content: center;
        }
        iron-icon {
          color: var(--primary-color-text-color-faded);
        }
        #overviewHeader {
          font-size: 10pt;
          font-weight: bolder;
          background-color: var(--primary-color);
          color: var(--primary-color-text-color);
        }
        #overviewHeader iron-icon {
          color: var(--primary-color-text-color);
        }
        #overviewHeader paper-cell:not(first-of-type):hover {
          cursor: pointer;
        }
        #pageElement {
          display: flex;
          flex-direction: column;
          height: 100%;
        }
        paper-input, pmp-simple-date-input, drop-down {
          --primary-color: var(--secondary-color);
        }
        .statusIcon {
          padding: 8px;
          background-color: var(--paper-grey-300);
          border-radius: 100%;
          /* @apply(--shadow-elevation-2dp); */
        }
        highlight-text {
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2; /* number of lines to show */
          line-height: 18px;        /* fallback */
          max-height: 36px;       /* fallback */
          --filter: {
            color: var(--paper-grey-600);
          };
          --match: {
            color: var(--primary-text-color);
          };
          --highlight: {
            background-color: var(--secondary-color);
            color: var(--secondary-color-text-color);
            padding: 2px;
          };
        }
        .iconButton {
          padding-right: 0px;
          transition: transform 0.3s;
        }
        @media (min-width: 600px) {
          #regionalAdminDialog {
            width: 600px;
          }
        }
        user-chip {
          padding: 0;
          --user-chip-profile: {
            height: 24px;
            width: 24px;
            font-size: 11pt;
          };
          --user-chip-name: {
            font-size: 10pt;
            margin-left: 8px;
            margin-right: 4px;
          };
        }
        .userChipWrapper {
          padding: 4px;
          margin: 2px;
          border-radius: 40px;
          background-color: var(--paper-grey-200);
          display: flex;
          justify-content: center;
          align-items: center;
          box-sizing: border-box;
        }
        .userChipWrapper katapult-button {
          height: 24px;
          width: 24px;
          padding: 2px;
        }
        .centerTitle {
          display: flex;
          justify-content: space-between;
          align-items: center;
          position:relative;
        }
        .centerTitle span {
          font-size: 12pt;
          font-weight: bold;
          color: var(--paper-grey-600);
        }
        drop-down {
          text-align: left;
          /* --paper-input-container-underline: {
            display: none;
          }; */
        }
        #authContentWrapper, #contentWrapper {
          display: flex;
          flex-direction: column;
          min-height:0;
          height: 100%;
        }
        paper-item, paper-icon-item {
          background-color: white;
          padding: 0 16px;
          white-space: nowrap;
        }
        paper-item.secondary:hover, paper-icon-item:hover, paper-item.secondary.hover {
          cursor: pointer;
          background-color: var(--secondary-color);
          color: var(--secondary-color-text-color);
          --paper-item-focused-before: {
            background-color: transparent;
          };
        }
        paper-item.secondary:hover iron-icon, paper-icon-item:hover iron-icon {
          color: var(--secondary-color-text-color);
        }
        .appOtherAttributesContainer {
          display: flex;
          flex-wrap: wrap;
          padding: 8px 48px;
        }
        .otherAppAttributeWrapper {
          display: flex;
          flex-direction: column;
          margin: 16px;
        }
        .otherAttributeHeader {
          font-size: 10pt;
          margin-bottom: 4px;
          /* font-weight: bolder; */
          color: var(--paper-grey-600);
          /* background-color: var(--primary-color); */
          /* color: white; */
        }
        .toggleAppRowButton:not([animate=""]) {
          transition: none;
        }
        .toggleAppRowButton[rotate=""] {
          transform: rotate(-180deg);
        }
        paper-toggle-button {
          --primary-color: var(--secondary-color);
        }
        #attacherListCollapse {
          position:relative;
        }
        .collapseRow {
          cursor:pointer;
        }
        .collapseRow:hover {
          background-color: var(--paper-grey-100);
        }
        .collapseRow iron-icon {
          margin:0 10px;
        }
        .collapseRow span {
          flex-grow:1;
          text-align:left;
        }
        .collapseContent {
          padding:0 24px;
        }
        .attacherRow {
          padding: 0 10px;
          --paper-input-container-disabled: {
            opacity:1;
            pointer-events:auto;
          }
          --paper-input-container-underline-disabled: {
              display:none;
          }
        }
        .attacherRow:hover {
          background-color: var(--paper-grey-100);
        }
        .attacherRow katapult-button {
          margin-left:10px;
        }
        .attacherRow:not(:hover) .editButton {
          opacity:0;
          pointer-events:none;
        }
        .attacherRow paper-input {
          text-align:left;
          width:420px;
        }
        .addButton {
          position:absolute;
          top:-46px;
          right:0;
        }
        .commitAttacherButton {
          padding: 5px;
          display: inline-block;
          min-width: 0;
          text-align: center;
        }
        #appTypeFilter > div[slot="dropdown-trigger"] {
          display: flex;
          flex-direction: row;
          align-items: center;
          gap: 8px;
          background-color: var(--paper-grey-200);
          padding: 8px 12px;
          border-radius: 80px;
        }
        .appTypeFilterRow {
          display: flex;
          align-items: center;
          height: 48px;
          padding: 16px;
          box-sizing: border-box;
        }
        .rowButton {
          background-color: var(--sl-color-neutral-200);
        }
        .rowButton:hover {
          cursor: pointer;
          background-color: var(--sl-color-neutral-300);
        }
        .rowButton paper-cell {
          max-width: initial;
        }
        .loading-overlay {
          z-index: 1;
          position: absolute;
          height: 100%;
          width: 100%;
          display: flex;
          flex-direction: column;
          gap: var(--sl-spacing-medium);
          justify-content: center;
          align-items: center;
          font-size: var(--sl-font-size-large);
          font-weight: var(--sl-font-weight-semibold);
          color: var(--sl-color-neutral-700);
          opacity: 0;
          background-color: rgba(255,255,255,0);
          transition: backdrop-filter 0.3s, background-color 0.3s;
          backdrop-filter: none;
          pointer-events: none;
        }
        .loading-overlay[visible] {
          opacity: 1;
          background-color: rgba(255,255,255,0.5);
          backdrop-filter: blur(1px);
          pointer-events: auto;
        }
        s-circle-progress {
          margin: 0;
          flex-shrink: 0;
          height: 24px;
          width: 24px;
          --s-circle-progress-transition: stroke-dashoffset 0;
          --s-circle-progress-stroke-color:var(--paper-grey-700);
          --s-circle-progress-bg-stroke-color: var(--paper-grey-100);
        }
        .export-status-container {
          position: relative;
        }
        .export-status-container > * {
          transition: opacity 0.2s ease;
        }
        .export-status-container s-circle-progress {
          position: absolute;
          top: 0;
          left: 0;
        }
        #infoContainer {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          flex: 1;
          font-size: 20px
        }
        sl-button[variant="default"]:not([disabled]):hover::part(base) {
          background-color: var(--sl-color-neutral-0);
        }
        .light-link {
          color: white;
          font-weight: normal;
          text-decoration: none;
        }
        #jobLoadingProgress {
          visibility: 'hidden';
          --height: 8px;
          margin: calc(var(--height) / -2) 0;
          z-index: 4;
        }
        #jobLoadingProgress::part(base) {
          border-radius: unset;
        }
        #createButton[disabled] {
          pointer-events: auto;
          cursor: not-allowed;
        }
      </style>

      <!-- NO-FLOW ELEMENTS -->
      <excel-exports id="excelExports" user-group="[[userGroup]]"></excel-exports>
      <paper-toast id="toast"></paper-toast>

      <!-- DIALOGS -->

      <!-- Timeline dialog -->
      <katapult-dialog-legacy id="editTimelineDialog" style="width: 420px;" no-cancel-on-outside-click>
        <span slot="title">App Timeline Editor</span>
        <span slot="subtitle">APP_[[timelineEditMetadata.app_number]]</span>

        <div slot="body">
          <app-timeline-editor
            id="appTimelineEditor"
            job-id="[[timelineEditJobId]]"
            user-group="[[userGroup]]"
            models="[[portalConfig.timeline_models]]"
            show-action-buttons=""
          ></app-timeline-editor>
          <katapult-firebase-worker
            path="photoheight/jobs/[[timelineEditJobId]]/metadata"
            data="{{timelineEditMetadata}}"
          ></katapult-firebase-worker>

          <template is="dom-repeat" items="[[timelineEditMetadata.timeline.stages]]" as="stage">
            <div style="display: flex;">
              <paper-input
                index="[[index]]"
                style="flex: 1; margin-right: 16px;"
                label="[[stage.name]] Duration"
                type="number"
                value="[[stage.length]]"
                data-path="_timelineMetadataUpdate.metadata.timeline.stages.$(model.index).length"
                data-parse="int"
                on-input="updateProperty"
                ><span slot="suffix">Days</span></paper-input
              >
              <pmp-simple-date-input
                start-date="[[stage.start_date]]"
                index="[[index]]"
                style="flex: 1;"
                placeholder=""
                label="Start Date (MM/DD/YY)"
                value="[[formatTimelineDate(stage.start_date)]]"
                data-path="_timelineMetadataUpdate.metadata.$(model.stage.start_date)"
                data-parse="date"
                on-input="updateProperty"
              ></pmp-simple-date-input>
            </div>
          </template>
        </div>

        <div slot="buttons" style="width: 100%; display: flex; justify-content: space-between;">
          <katapult-button dialog-dismiss data-action="cancel" on-click="closeEditTimelineDialog">Cancel</katapult-button>
          <katapult-button dialog-confirm data-action="save" on-click="closeEditTimelineDialog" color="var(--secondary-color)"
            >Save</katapult-button
          >
        </div>
      </katapult-dialog-legacy>

      <!-- Admin dialog -->
      <!-- TODO (08-31-2023): This should eventually be removed, as the settings are not being used anywhere anymore -->
      <template is="dom-if" if="[[and(systemAdmin, portalConfig.show_regional_admin_tools)]]">
        <paper-dialog
          id="regionalAdminDialog"
          opened="{{regionalAdminDialogOpened}}"
          entry-animation="scale-up-animation"
          exit-animation="fade-out-animation"
          no-cancel-on-esc-key
          no-cancel-on-outside-click
        >
          <div title="" secondary-color="">App Portal Configuration</div>
          <paper-dialog-scrollable>
            <div class="content">
              <paper-item class="collapseRow" name="attacherListCollapse" on-click="toggleCollapse">
                <iron-icon icon="communication:business"></iron-icon>
                <span>Attachers on Record</span>
                <katapult-button
                  class="toggleAppRowButton"
                  icon="keyboard_arrow_down"
                  iconOnly
                  noBorder
                  noBackground
                  rotate$="[[attacherListOpen]]"
                ></katapult-button>
              </paper-item>
              <iron-collapse id="attacherListCollapse" opened="{{attacherListOpen}}">
                <div class="collapseContent">
                  <katapult-button class="addButton" icon="add" color="var(--secondary-color)" on-click="editAttacherAddOpen"
                    >Add Attacher</katapult-button
                  >
                  <template is="dom-if" if="[[showAddAttacher]]">
                    <paper-item class="attacherRow">
                      <paper-input id="newAttacher" no-label-float="" label="New Attacher Name" value="{{newAttacherName}}">
                        <katapult-button
                          icon="close"
                          slot="suffix"
                          title="Cancel"
                          iconOnly
                          noBorder
                          noBackground
                          on-click="editAttacherAddClose"
                        ></katapult-button>
                        <katapult-button
                          icon="check"
                          slot="suffix"
                          title="Save"
                          iconOnly
                          noBorder
                          noBackground
                          on-click="editAttacherSave"
                        ></katapult-button>
                      </paper-input>
                    </paper-item>
                  </template>
                  <template is="dom-repeat" items="[[toArray(attachers)]]">
                    <paper-item class="attacherRow">
                      <paper-input
                        id$="edit[[item.$key]]"
                        disabled$="[[!equal(item.$key, editingAttacher)]]"
                        no-label-float=""
                        value="[[item.name]]"
                      >
                        <template is="dom-if" if="[[!equal(item.$key, editingAttacher)]]">
                          <katapult-button
                            icon="create"
                            slot="suffix"
                            iconOnly
                            noBorder
                            noBackground
                            on-click="editAttacher"
                            class="editButton"
                          ></katapult-button>
                        </template>
                        <template is="dom-if" if="[[equal(item.$key, editingAttacher)]]">
                          <katapult-button
                            icon="close"
                            slot="suffix"
                            title="Cancel"
                            iconOnly
                            noBorder
                            noBackground
                            on-click="editAttacherCancel"
                          ></katapult-button>
                          <katapult-button
                            icon="check"
                            slot="suffix"
                            title="Save"
                            iconOnly
                            noBorder
                            noBackground
                            on-click="editAttacherSave"
                          ></katapult-button>
                        </template>
                      </paper-input>
                    </paper-item>
                  </template>
                </div>
              </iron-collapse>
            </div>
          </paper-dialog-scrollable>
          <div class="buttons">
            <katapult-button class="dismiss" dialog-dismiss>Close</katapult-button>
          </div>
        </paper-dialog>
      </template>

      <!-- Status dialogs -->
      <!-- TODO: this dialog needs to be converted to a katapult-dialog so that it can be a proper modal -->
      <paper-dialog
        id="notApprovedDialog"
        entry-animation="scale-up-animation"
        exit-animation="fade-out-animation"
        no-cancel-on-esc-key
        no-cancel-on-outside-click
      >
        <div title="" amber=""><iron-icon icon="hourglass-empty"></iron-icon>Pending Approval</div>
        <div content="">
          <p>[[pendingApprovalText]]</p>
        </div>
        <div buttons="">
          <katapult-button dialog-dismiss>Close</katapult-button>
        </div>
      </paper-dialog>
      <!-- TODO: this dialog needs to be converted to a katapult-dialog so that it can be a proper modal -->
      <paper-dialog
        id="needToRequestDialog"
        entry-animation="scale-up-animation"
        exit-animation="fade-out-animation"
        no-cancel-on-esc-key
        no-cancel-on-outside-click
      >
        <div title="" secondary-color="">No Permission Requested</div>
        <div style="text-align: center;" content="">
          <div>Your company does not have permission to submit on behalf of any companies</div>
          <template is="dom-if" if="[[or(admin, systemAdmin)]]">
            <div>You can request permission from the admin panel</div>
          </template>
          <template is="dom-if" if="[[!or(admin, systemAdmin)]]">
            <div>A company admin can request permission from the admin panel</div>
          </template>
        </div>
        <div buttons="">
          <template is="dom-if" if="[[or(admin, systemAdmin)]]">
            <a style="text-decoration: none;" href="../admin"
              ><katapult-button color="var(--secondary-color)">Go to Admin Panel</katapult-button></a
            >
          </template>
        </div>
      </paper-dialog>

      <!-- AUTH WRAPPER -->
      <katapult-auth
        user="{{user}}"
        user-group="{{userGroup}}"
        user-record="{{userRecord}}"
        can-read="{{userCanRead}}"
        can-write="{{userCanWrite}}"
        email="{{loginEmailBox}}"
        signed-in="{{signedIn}}"
        admin="{{admin}}"
        system-admin="{{systemAdmin}}"
        root-company="{{rootCompany}}"
        title="[[pageTitle]]"
        no-signup="[[!config.firebaseData.offerLicenses]]"
      >
        <!-- Auth loading details -->
        <div slot="title-content">
          <p style="margin: 0;">[[pageTitle]]</p>
        </div>
        <div slot="description-content">
          <template is="dom-if" if="[[isPortalServer]]" restamp>
            <p>[[pageTitle]] allows you to see your submitted applications and create new ones.</p>
            <p hidden$="[[!gettingStartedLink]]">
              First time here? View the
              <a href$="[[gettingStartedLink]]" class="light-link" target="_blank">Getting Started</a>
              guide.
            </p>
            <p>
              If you have questions or need support, please call us at 717-430-0910 or email us at
              <a class="light-link" href="mailto:support@katapultengineering.com">support@katapultengineering.com</a>
            </p>
          </template>
          <template is="dom-if" if="[[!isPortalServer]]">
            <p>The Overview page provides insight and quick access to your Workflows.</p>
          </template>
        </div>

        <!-- Pole app sign up form -->
        <pole-application-sign-up-form slot="sign-up-form" config="[[config]]" email="{{loginEmailBox}}"></pole-application-sign-up-form>

        <!-- AUTH CONTENT -->
        <div id="authContentWrapper" slot="auth-content">
          <!-- NO-FLOW ELEMENTS -->
          <!-- Read only -->
          <katapult-firebase-worker
            path="photoheight/company_space/[[userGroup]]/options/job_chooser"
            data="{{jobChooserOptions}}"
            disabled="[[!signedIn]]"
          ></katapult-firebase-worker>
          <katapult-firebase-worker
            id="attacherList"
            path="photoheight/company_space/[[userGroup]]/attacher_list"
            data="{{attacherList}}"
            loading="{{attacherListLoading}}"
            disabled="[[!signedIn]]"
          ></katapult-firebase-worker>
          <katapult-firebase-worker path="photoheight/companies" data="{{companies}}" disabled="[[!signedIn]]"></katapult-firebase-worker>
          <katapult-firebase-worker
            path="photoheight/company_space/[[userGroup]]/model_options"
            disabled="[[!signedIn]]"
            loading="{{modelsForSelectionLoading}}"
            data="{{modelOptions}}"
          ></katapult-firebase-worker>
          <katapult-firebase-worker
            path="photoheight/white_label/utility_models"
            data="{{serverUtilityModels}}"
            disabled="[[!signedIn]]"
          ></katapult-firebase-worker>
          <katapult-firebase-worker path="utility_info/[[selectedModel]]/attachers" data="{{attachers}}"></katapult-firebase-worker>
          <iron-a11y-keys keys="esc" on-keys-pressed="hideFilters"></iron-a11y-keys>

          <!-- Toolbar -->
          <katapult-toolbar user-group="[[userGroup]]" hide-camera-info>
            <!-- Left Content -->
            <div slot="left" style="flex: 1; display: flex; justify-content: space-between;">
              <div style="display: flex; flex-direction: row; align-items: center;">
                <div style="padding-right: var(--sl-spacing-small);">
                  <template is="dom-if" if="[[modelsForSelectionLoading]]">
                    <sl-spinner style="font-size: 24px;"></sl-spinner>
                  </template>
                  <template is="dom-if" if="[[!modelsForSelectionLoading]]">
                    <template is="dom-if" if="[[!is3PAPortalModel]]">
                      <katapult-icon icon="group-work" inferType></katapult-icon>
                    </template>
                    <template is="dom-if" if="[[is3PAPortalModel]]">
                      <sl-tooltip content="Third-Party Attachments Portal">
                        <katapult-icon icon="design_services"></katapult-icon>
                      </sl-tooltip>
                    </template>
                  </template>
                </div>
                <div style="width: 180px">
                  <template is="dom-if" if="[[showSingleModelName(modelsForSelection.*, selectedModel, companies)]]">
                    <span>[[showSingleModelName(modelsForSelection.*, selectedModel, companies)]]</span>
                  </template>
                  <template is="dom-if" if="[[!showSingleModelName(modelsForSelection.*, selectedModel, companies)]]">
                    <katapult-drop-down
                      label="Select a Model"
                      items="[[modelsForSelection]]"
                      value="{{selectedModel}}"
                      value-path="value"
                      label-path="label"
                      no-label-float
                      disabled="[[filteringJobs]]"
                      style="margin-right: var(--sl-spacing-small);"
                    ></katapult-drop-down>
                  </template>
                </div>
              </div>
              <template is="dom-if" if="[[workflowVisibility.length]]">
                <sl-dropdown style="display: flex; align-items: center;" stay-open-on-select look-like-paper-element>
                  <sl-button slot="trigger" caret>
                    <katapult-icon icon="assignment" slot="prefix" size="24"></katapult-icon>
                    <div style="display: flex; gap: var(--sl-spacing-2x-small); align-items: center;">
                      <span>[[getWorkflowVisibilitySummary(workflowVisibility.*)]]</span>
                      <!-- <katapult-icon icon="info" size="20" outline></katapult-icon> -->
                    </div>
                  </sl-button>
                  <sl-menu on-sl-select="toggleWorkflowVisibility">
                    <sl-menu-label>Workflows to Show</sl-menu-label>
                    <template is="dom-if" if="[[showAllWorkflowsVisibleButton]]">
                      <sl-menu-item value="_ALL_WORKFLOWS" type="checkbox" checked="[[allWorkflowsVisible]]"
                        >Show all Workflows</sl-menu-item
                      >
                      <sl-divider></sl-divider>
                    </template>
                    <template is="dom-repeat" items="[[workflowVisibility]]">
                      <template is="dom-if" if="[[equal(item.workflowId, '_NO_WORKFLOW')]]">
                        <sl-divider></sl-divider>
                        <sl-menu-label>Other View Options</sl-menu-label>
                      </template>
                      <sl-menu-item value="[[item.workflowId]]" type="checkbox" checked="[[item.visible]]"
                        >[[getWorkflowLabel(item.workflowId, true)]]</sl-menu-item
                      >
                    </template>
                  </sl-menu>
                </sl-dropdown>
              </template>
            </div>

            <!-- Center Content -->
            <app-filter-input
              slot="center"
              style="align-self: flex-start; z-index: 1;"
              filtered-overview-attributes="[[filteredOverviewAttributes]]"
              company-attributes="[[companyAttributes]]"
              attachers="[[attachers]]"
              portal-app-statuses="[[portalAppStatuses]]"
              filter-on-admin-strategy="[[filterOnAdminStrategy]]"
              companies="[[companies]]"
              filtering-jobs="[[showFilteringSpinner(filteringJobs, waitingForInitialJobData)]]"
              total-jobs="[[getTotalJobCount(sortedFilteredJobRefs, numHiddenJobs)]]"
              total-drafts="[[getTotalDraftCount(showDrafts, numDrafts)]]"
              on-filters-updated="updateFilters"
              selected-model="[[selectedModel]]"
              user-group="[[userGroup]]"
              user-id="[[user.uid]]"
              workflow-visibility="[[workflowVisibility]]"
              on-saved-filter-loaded="savedFilterLoaded"
            ></app-filter-input>

            <!-- Right content -->
            <div style="flex-grow: 1;" slot="right"></div>
            <template is="dom-if" if="[[showCreateButton(approvedToSubmit, portalConfig.allow_drafts_before_approval)]]">
              <paper-menu-button
                id="createMenu"
                slot="right"
                horizontal-align="left"
                vertical-align="top"
                vertical-offset="48"
                horizontal-offset="8"
                disabled="[[createButtonDisabled]]"
              >
                <sl-tooltip
                  slot="dropdown-trigger"
                  placement="left"
                  content="[[getCreateButtonTooltipText(selectedModel, userCanWrite, userIsAppManager, is3PAPortalModel)]]"
                >
                  <katapult-button
                    id="createButton"
                    icon="add"
                    color="var(--secondary-color)"
                    loader-in-button=""
                    disabled="[[createButtonDisabled]]"
                    >[[createButtonText]]</katapult-button
                  >
                </sl-tooltip>
                <div slot="dropdown-content">
                  <template is="dom-repeat" items="[[createAppTypes]]">
                    <paper-item class="secondary" on-click="createApplication">[[item.display_name]]</paper-item>
                  </template>
                </div>
              </paper-menu-button>
            </template>

            <div style="display: flex; justify-content: center; align-items: center;" slot="right">
              <paper-menu-button id="exportMenu" horizontal-align="left" vertical-align="top" vertical-offset="48" horizontal-offset="-65">
                <!-- Generic Exports -->
                <katapult-button id="exportButton" icon="trending_up" iconOnly noBorder slot="dropdown-trigger"></katapult-button>
                <div slot="dropdown-content">
                  <paper-icon-item disabled="[[runningExports.overview.isRunning]]" data-export-type="Overview" on-click="export">
                    <div slot="item-icon" class="export-status-container">
                      <katapult-icon icon="format_list_bulleted" invisible$="[[runningExports.overview.isRunning]]"></katapult-icon>
                      <s-circle-progress
                        value="[[runningExports.overview.progress]]"
                        max="1"
                        invisible$="[[!runningExports.overview.isRunning]]"
                      ></s-circle-progress>
                    </div>
                    <span>Overview Export</span>
                  </paper-icon-item>

                  <paper-icon-item disabled="[[runningExports.kmz.isRunning]]" data-export-type="KMZ" on-click="export">
                    <div slot="item-icon" class="export-status-container">
                      <katapult-icon icon="share" invisible$="[[runningExports.kmz.isRunning]]"></katapult-icon>
                      <s-circle-progress
                        value="[[runningExports.kmz.progress]]"
                        max="1"
                        invisible$="[[!runningExports.kmz.isRunning]]"
                      ></s-circle-progress>
                    </div>
                    <span>KMZ Export</span>
                  </paper-icon-item>

                  <!-- 3PA Specific Exports -->
                  <template is="dom-if" if="[[is3PAPortalModel]]">
                    <paper-icon-item disabled="[[runningExports.apps.isRunning]]" data-export-type="Apps" on-click="export">
                      <div slot="item-icon" class="export-status-container">
                        <katapult-icon icon="circle" invisible$="[[runningExports.apps.isRunning]]"></katapult-icon>
                        <s-circle-progress
                          value="[[runningExports.apps.progress]]"
                          max="1"
                          invisible$="[[!runningExports.apps.isRunning]]"
                        ></s-circle-progress>
                      </div>
                      <span>App Export</span>
                    </paper-icon-item>

                    <template is="dom-if" if="[[enabledFeatures.ppl_preconstruction_portal_export]]">
                      <paper-icon-item
                        disabled="[[runningExports.preconstruction.isRunning]]"
                        data-export-type="Preconstruction"
                        on-click="export"
                      >
                        <div slot="item-icon" class="export-status-container">
                          <katapult-icon icon="construction" invisible$="[[runningExports.preconstruction.isRunning]]"></katapult-icon>
                          <s-circle-progress
                            value="[[runningExports.preconstruction.progress]]"
                            max="1"
                            invisible$="[[!runningExports.preconstruction.isRunning]]"
                          ></s-circle-progress>
                        </div>
                        <span>PPL Pre-Construction Export</span>
                      </paper-icon-item>
                    </template>

                    <template is="dom-if" if="[[showCostExport(systemAdmin, config.appName)]]">
                      <paper-icon-item disabled="[[runningExports.cost.isRunning]]" data-export-type="Cost" on-click="export">
                        <div slot="item-icon" class="export-status-container">
                          <katapult-icon icon="attach_money" invisible$="[[runningExports.cost.isRunning]]"></katapult-icon>
                          <s-circle-progress
                            value="[[runningExports.cost.progress]]"
                            max="1"
                            invisible$="[[!runningExports.cost.isRunning]]"
                          ></s-circle-progress>
                        </div>
                        <span>Cost Export</span>
                      </paper-icon-item>
                    </template>

                    <paper-icon-item disabled="[[runningExports.poles.isRunning]]" data-export-type="Poles" on-click="export">
                      <div slot="item-icon" class="export-status-container">
                        <katapult-icon icon="library_books" invisible$="[[runningExports.poles.isRunning]]"></katapult-icon>
                        <s-circle-progress
                          value="[[runningExports.poles.progress]]"
                          max="1"
                          invisible$="[[!runningExports.poles.isRunning]]"
                        ></s-circle-progress>
                      </div>
                      <span>Poles Export</span>
                    </paper-icon-item>

                    <template is="dom-if" if="{{showInvoiceExport(userGroup)}}">
                      <paper-icon-item disabled="[[runningExports.ppl_invoice.isRunning]]" data-export-type="PPL Invoice" on-click="export">
                        <div slot="item-icon" class="export-status-container">
                          <katapult-icon icon="attach_money" invisible$="[[runningExports.ppl_invoice.isRunning]]"></katapult-icon>
                          <s-circle-progress
                            value="[[runningExports.ppl_invoice.progress]]"
                            max="1"
                            invisible$="[[!runningExports.ppl_invoice.isRunning]]"
                          ></s-circle-progress>
                        </div>
                        <span>PPL Invoice Tracking Export</span>
                      </paper-icon-item>

                      <paper-icon-item
                        disabled="[[runningExports.export_timeline.isRunning]]"
                        data-export-type="Export Timeline"
                        on-click="export"
                      >
                        <div slot="item-icon" class="export-status-container">
                          <katapult-icon icon="date_range" invisible$="[[runningExports.export_timeline.isRunning]]"></katapult-icon>
                          <s-circle-progress
                            value="[[runningExports.export_timeline.progress]]"
                            max="1"
                            invisible$="[[!runningExports.export_timeline.isRunning]]"
                          ></s-circle-progress>
                        </div>
                        <span>Timeline Export</span>
                      </paper-icon-item>
                      <paper-icon-item on-click="importTimeline"
                        ><katapult-icon icon="file_upload" slot="item-icon"></katapult-icon>Timeline Import</paper-icon-item
                      >
                      <input
                        id="importTimelineInput"
                        style="display: none;"
                        type="file"
                        accept=".csv"
                        on-change="importTimelineInputChanged"
                      />
                    </template>
                    <template is="dom-if" if="[[enabledFeatures.kpi_milestone_portal_export]]">
                      <paper-icon-item
                        disabled="[[runningExports.kpi_milestones.isRunning]]"
                        data-export-type="KPI Milestones"
                        on-click="export"
                      >
                        <div slot="item-icon" class="export-status-container">
                          <katapult-icon icon="insert_chart" invisible$="[[runningExports.kpi_milestones.isRunning]]"></katapult-icon>
                          <s-circle-progress
                            value="[[runningExports.kpi_milestones.progress]]"
                            max="1"
                            invisible$="[[!runningExports.kpi_milestones.isRunning]]"
                          ></s-circle-progress>
                        </div>
                        <span>KPI Milestones</span>
                      </paper-icon-item>
                    </template>
                    <template is="dom-if" if="[[enabledFeatures.cost_causer_splits_portal_export]]">
                      <paper-icon-item
                        disabled="[[runningExports.cost_causer_splits.isRunning]]"
                        data-export-type="Cost Causer Splits"
                        on-click="export"
                      >
                        <div slot="item-icon" class="export-status-container">
                          <katapult-icon icon="people_outline" invisible$="[[runningExports.cost_causer_splits.isRunning]]"></katapult-icon>
                          <s-circle-progress
                            value="[[runningExports.cost_causer_splits.progress]]"
                            max="1"
                            invisible$="[[!runningExports.cost_causer_splits.isRunning]]"
                          ></s-circle-progress>
                        </div>
                        <span>Cost Causer Splits</span>
                      </paper-icon-item>
                    </template>
                    <paper-icon-item disabled="[[runningExports.accrual.isRunning]]" data-export-type="Accrual" on-click="export">
                      <div slot="item-icon" class="export-status-container">
                        <katapult-icon icon="pie_chart" invisible$="[[runningExports.accrual.isRunning]]"></katapult-icon>
                        <s-circle-progress
                          value="[[runningExports.accrual.progress]]"
                          max="1"
                          invisible$="[[!runningExports.accrual.isRunning]]"
                        ></s-circle-progress>
                      </div>
                      <span>Accrual Export</span>
                    </paper-icon-item>
                  </template>
                </div>
              </paper-menu-button>
              <paper-tooltip animation-delay="0" for="exportButton">Export</paper-tooltip>

              <template is="dom-if" if="[[and(systemAdmin, portalConfig.show_regional_admin_tools)]]">
                <katapult-button
                  id="regionalAdminButton"
                  icon="settings"
                  iconOnly
                  noBorder
                  on-click="openRegionalAdminDialog"
                ></katapult-button>
                <paper-tooltip animation-delay="0" for="regionalAdminButton">Portal Configuration</paper-tooltip>
              </template>
            </div>
          </katapult-toolbar>

          <sl-progress-bar id="jobLoadingProgress"></sl-progress-bar>

          <!-- MAIN CONTENT -->
          <div id="contentWrapper">
            <!-- Data table -->
            <paper-table>
              <!-- Overview header -->
              <paper-row id="overviewHeader">
                <paper-cell></paper-cell>
                <!-- Status Cell -->
                <template is="dom-repeat" items="[[filteredOverviewAttributes]]" as="overviewAttribute">
                  <template is="dom-if" if="[[overviewAttribute.top_level]]">
                    <!-- TODO: User plain flex number and make this not so gross? making style$ is better -->
                    <paper-cell
                      style$="flex-grow: [[overviewAttribute.flex_grow]];"
                      on-click="updateSortAttribute"
                      on-mouseover="setHoveredAttributeHeader"
                      on-mouseout="clearHoveredAttributeHeader"
                    >
                      <span style="pointer-events: none;"
                        >[[_getColumnLabel(overviewAttribute.attribute, filteredOverviewAttributes, companyAttributes)]]</span
                      >

                      <template is="dom-if" if="[[equal(sortAttr, overviewAttribute.attribute)]]">
                        <iron-icon
                          style="pointer-events: none; margin-left: var(--sl-spacing-small);"
                          hidden$="[[!sortReverse]]"
                          icon="arrow-drop-down"
                        ></iron-icon>
                        <iron-icon
                          style="pointer-events: none; margin-left: var(--sl-spacing-small);"
                          hidden$="[[sortReverse]]"
                          icon="arrow-drop-up"
                        ></iron-icon>
                      </template>

                      <template is="dom-if" if="[[showHoverFilterIcon(sortAttr, overviewAttribute.attribute, hoveredAttributeHeader)]]">
                        <iron-icon
                          style="pointer-events: none; margin-left: var(--sl-spacing-small); height: 15px;"
                          icon="sort"
                        ></iron-icon>
                      </template>
                    </paper-cell>
                  </template>
                </template>

                <paper-cell class="button"></paper-cell>
                <!-- Toggle App Button Cell -->
                <paper-cell class="button"></paper-cell>
                <!-- Open App Button Cell -->
                <template is="dom-if" if="[[originIsDev]]">
                  <paper-cell class="button"></paper-cell>
                  <!-- Firebase Job Link Cell -->
                </template>
              </paper-row>

              <div class="loading-overlay" visible$="[[or(waitingForInitialJobData, hideResultsMessage)]]">
                <!-- If jobs are loading, show a spinner -->
                <template is="dom-if" if="[[waitingForInitialJobData]]">
                  <span>Waiting for first jobs to load...</span>
                  <sl-spinner style="font-size: 48px; --track-width: 6px"></sl-spinner>
                </template>
                <!-- If the results should be hidden, show a message instead -->
                <template is="dom-if" if="[[hideResultsMessage]]">
                  <span>[[hideResultsMessage]]</span>
                </template>
              </div>

              <!-- Only show data if the results should not be hidden -->
              <template is="dom-if" if="[[!hideResultsMessage]]">
                <!-- Data rows -->
                <iron-list id="appList" items="[[sortedFilteredJobRefs]]" on-scroll="ironListScroll">
                  <template>
                    <div class="appRow" on-dblclick="openApp" key="[[item.key]]" name="[[item.jobName]]">
                      <!-- Job row -->
                      <template is="dom-if" if="[[item.isJob]]" restamp="">
                        <paper-row>
                          <paper-cell>
                            <div class="statusIcon" style$="background-color: [[item.$statusColor]];"></div>
                          </paper-cell>

                          <template is="dom-repeat" items="[[item.$overviewAttributes]]" as="attr">
                            <template is="dom-if" if="[[attr.top_level]]">
                              <!-- TODO: on_click is not included in new config object -->
                              <paper-cell
                                style$="[[getAttributeStyle(item.$job.metadata, attr)]]"
                                clickable$="[[attr.on_click]]"
                                app-id="[[item.key]]"
                                attr="[[attr]]"
                                on-click="attributeClickHandler"
                                on-dblclick="attributeDoubleClickHandler"
                              >
                                <!-- TODO (10-06-2022): These highlight-text guys mess with font-colors, not a problem with normal text, but color on color looks weird -->
                                <template is="dom-if" if="[[equal(attr.display_as, 'date')]]" restamp="">
                                  <highlight-text title$="[[formatDate(attr.$value)]]" filters="[[getHighlightFilters(searchString, attr)]]"
                                    ><span>[[formatDate(attr.$value)]]</span></highlight-text
                                  >
                                </template>

                                <template is="dom-if" if="[[equal(attr.display_as, 'company')]]" restamp="">
                                  <highlight-text
                                    title$="[[getCompanyName(attr.$value, attr.attribute)]]"
                                    filters="[[getHighlightFilters(searchString, attr)]]"
                                    ><span>[[getCompanyName(attr.$value, attr.attribute)]]</span></highlight-text
                                  >
                                </template>

                                <template is="dom-if" if="[[equal(attr.display_as, 'user')]]" restamp>
                                  <template is="dom-if" if="[[attr.$value]]" restamp>
                                    <user-chip uid="[[attr.$value]]"></user-chip>
                                  </template>
                                </template>

                                <template is="dom-if" if="[[equal(attr.display_as, 'boolean')]]" restamp="">
                                  <paper-checkbox checked="[[attr.$value]]" disabled=""></paper-checkbox>
                                </template>

                                <template is="dom-if" if="[[equal(attr.display_as, 'computed')]]" restamp="">
                                  <highlight-text
                                    title$="[[calcComputedOverviewAttribute(attr, item.$job.metadata)]]"
                                    filters="[[getHighlightFilters(searchString, attr)]]"
                                    ><span>[[calcComputedOverviewAttribute(attr, item.$job.metadata)]]</span></highlight-text
                                  >
                                </template>

                                <template is="dom-if" if="[[equal(attr.display_as, 'job_attribute')]]" restamp>
                                  <highlight-text
                                    title$="[[getSub(item.$job, attr.attribute)]]"
                                    filters="[[getHighlightFilters(searchString, attr)]]"
                                    ><span>[[getSub(item.$job, attr.attribute)]]</span></highlight-text
                                  >
                                </template>

                                <template is="dom-if" if="[[equal(attr.attribute, 'action_buttons')]]" restamp>
                                  <overview-actions-button
                                    job-id="[[item.key]]"
                                    job-name="[[item.$job.name]]"
                                    job-model="[[item.$job.job_creator]]"
                                    job-metadata="[[item.$job.metadata]]"
                                    user-group="[[userGroup]]"
                                    enabled-features="[[enabledFeatures]]"
                                    attachers="[[attachers]]"
                                  ></overview-actions-button>
                                </template>

                                <template is="dom-if" if="[[isPlainTextOverviewCell(attr)]]" restamp="">
                                  <highlight-text title$="[[attr.$value]]" filters="[[getHighlightFilters(searchString, attr)]]"
                                    ><span>[[attr.$value]]</span></highlight-text
                                  >
                                </template>
                              </paper-cell>
                            </template>
                          </template>

                          <paper-cell class="button">
                            <katapult-button
                              app-id="[[item.key]]"
                              class="toggleAppRowButton"
                              icon="keyboard_arrow_down"
                              iconOnly
                              noBorder
                              noBackground
                              rotate$="[[item.$display.rowExpanded]]"
                              animate$="[[item.$display.animateExpand]]"
                              on-click="toggleAppRow"
                              on-dblclick="stopPropagation"
                            ></katapult-button>
                          </paper-cell>

                          <paper-cell class="button">
                            <a href$="[[getAppUrl(item.key)]]" target="_blank"
                              ><katapult-button icon="open_in_new" iconOnly noBorder noBackground></katapult-button
                            ></a>
                          </paper-cell>

                          <template is="dom-if" if="[[originIsDev]]">
                            <paper-cell class="button">
                              <a
                                href$="https://console.firebase.google.com/u/1/project/[[config.appName]]/database/[[config.appName]]/data/photoheight/jobs/[[item.key]]"
                                ><katapult-button icon="link" iconOnly noBorder noBackground></katapult-button
                              ></a>
                            </paper-cell>
                          </template>
                        </paper-row>

                        <iron-collapse
                          app-id="[[item.key]]"
                          opened="[[item.$display.rowExpanded]]"
                          no-animation="[[!item.$display.animateExpand]]"
                          on-transitioning-changed="appExpandTransitionChanged"
                        >
                          <div class="appOtherAttributesContainer">
                            <template
                              is="dom-if"
                              if="[[item.$display.showCollapseContent]]"
                              restamp=""
                              on-dom-change="collapseContentChanged"
                            >
                              <template is="dom-repeat" items="[[item.$overviewAttributes]]" as="attr">
                                <template is="dom-if" if="[[!attr.top_level]]">
                                  <template is="dom-if" if="[[attr.$value]]">
                                    <div class="otherAppAttributeWrapper">
                                      <span class="otherAttributeHeader">[[getAttributeName(attr)]]:</span>
                                      <template is="dom-if" if="[[equal(attr.display_as, 'date')]]" restamp="">
                                        <highlight-text filters="[[getHighlightFilters(searchString, attr)]]"
                                          ><span>[[formatDate(attr.$value)]]</span></highlight-text
                                        >
                                      </template>

                                      <template is="dom-if" if="[[equal(attr.display_as, 'company')]]" restamp="">
                                        <highlight-text filters="[[getHighlightFilters(searchString, attr)]]"
                                          ><span>[[getCompanyName(attr.$value, attr.attribute)]]</span></highlight-text
                                        >
                                      </template>

                                      <template is="dom-if" if="[[equal(attr.display_as, 'boolean')]]" restamp="">
                                        <paper-checkbox checked="[[attr.$value]]" disabled=""></paper-checkbox>
                                      </template>

                                      <template is="dom-if" if="[[!attr.display_as]]" restamp="">
                                        <highlight-text filters="[[getHighlightFilters(searchString, attr)]]"
                                          ><span>[[attr.$value]]</span></highlight-text
                                        >
                                      </template>
                                    </div>
                                  </template>
                                </template>
                              </template>
                            </template>
                          </div>
                        </iron-collapse>
                      </template>

                      <!-- Non-job row -->
                      <template is="dom-if" if="[[!item.isJob]]" restamp>
                        <template is="dom-if" if="[[item.show_drafts]]" restamp>
                          <div class="rowButton" on-click="showAllDrafts">
                            <paper-row><paper-cell>Show [[numDrafts]] Drafts</paper-cell></paper-row>
                          </div>
                        </template>
                      </template>
                    </div>
                  </template>
                </iron-list>
                <template is="dom-if" if="[[numHiddenJobs]]" restamp>
                  <div class="rowButton" on-click="showAllHiddenJobs">
                    <paper-row><paper-cell ripple>Show [[numHiddenJobs]] Hidden Jobs</paper-cell></paper-row>
                  </div>
                </template>
              </template>
            </paper-table>
          </div>
        </div>
      </katapult-auth>
    `;
  }

  static get is() {
    return 'pole-application-overview';
  }

  static get importMeta() {
    return import.meta;
  }

  static get properties() {
    return {
      appOptions: {
        type: Object,
        value: () => ({})
      },
      attacherList: {
        type: Object
      },
      approvedToSubmit: {
        type: Boolean,
        value: false
      },
      createButtonText: {
        type: String,
        value: 'Create'
      },
      filterAttributeValues: {
        type: Object,
        value: () => ({})
      },
      filteredOverviewAttributes: {
        type: Array,
        value: null
      },
      waitingForInitialJobData: {
        type: Boolean,
        value: true
      },
      numJobsToShow: {
        type: Number,
        value: 100
      },
      portalAppStatuses: {
        type: Array,
        computed: 'calcPortalAppStatuses(portalConfig.app_types)'
      },
      rootCompany: {
        type: String,
        value: null
      },
      showCompletedApps: {
        type: Boolean,
        value: false
      },
      showDrafts: {
        type: Boolean,
        value: false
      },
      showDuplicated: {
        type: Boolean,
        value: false
      },
      sortAttr: {
        type: String,
        value: 'app_number'
      },
      sortReverse: {
        type: Boolean,
        value: true
      },
      sortedFilteredJobRefs: {
        type: Array,
        value: () => []
      },
      numDrafts: {
        type: Number,
        value: 0
      },
      createAppTypes: {
        type: Array,
        value: () => []
      },
      workflowVisibility: {
        type: Array,
        value: () => []
      },
      filteringJobs: {
        type: Boolean,
        value: false
      },
      runningExports: {
        type: Object,
        value: () => ({})
      },
      enabledFeatures: {
        type: Object,
        value: () => ({})
      },
      filterOnAdminStrategy: {
        type: Boolean,
        computed: 'computeFilterOnAdminStrategy(userGroup, selectedModel, modelOwner, portalConfig.user_options.admin_strategy)'
      },
      signedIn: {
        type: Boolean,
        value: false,
        observer: 'signedInChanged'
      },
      modelsForSelection: {
        type: Array,
        value: null
      },
      selectedModel: {
        type: String,
        value: null
      },
      is3PAPortalModel: {
        type: Boolean,
        value: false
      },
      userGroup: {
        type: String,
        value: null,
        observer: 'userGroupChanged'
      },
      gettingStartedLink: {
        type: String
      },
      showAllWorkflowsVisibleButton: {
        type: Boolean,
        value: false
      },
      allWorkflowsVisible: {
        type: Boolean,
        value: false
      },
      createButtonDisabled: {
        type: Boolean,
        computed: 'computeCreateButtonDisabled(userCanWrite, userIsAppManager, selectedModel)'
      }
    };
  }

  static get observers() {
    return [
      'updateWorkflowVisibility(portalConfig.app_types)',
      'calcCreateAppTypes(portalConfig.app_types, userGroup, selectedModel, modelOwner, portalConfig.user_options.review_contractors, attacherList.*)',
      'updateOverviewWorkerJobFilterOptions(filteredOverviewAttributes, jobChooserOptions, searchString, sortAttr, sortReverse, filterAttributeValues.*, showDuplicated, showCompletedApps, showDrafts, workflowVisibility.*, numJobsToShow, portalConfig.app_types)',
      'updateOverviewWorkerIncludeArchived(showArchived)',
      'logOverviewLoaded(user.uid)',
      'updateApprovedToSubmit(userGroup, selectedModel, modelOwner, attacherList.*, attacherListLoading, userCanRead, is3PAPortalModel)',
      'setDefaultSortAttribute(portalConfig.default_sort_attribute)',
      'selectedModelChanged(selectedModel)',
      'getModelsForSelection(modelOptions, userGroup, companies, serverUtilityCompany, serverUtilityModels, attacherList)',
      'setStartingModel(modelsForSelection.*, signedIn)',
      'calcFilteredOverviewAttributes(portalConfig, userGroup, selectedModel, modelOwner, companyAttributes)',
      'setIs3PAPortalModel(portalConfig.is_3pa_portal_model, serverUtilityCompany, selectedModel)',
      'setHideResultsMessage(selectedModel, modelsForSelectionLoading, modelsForSelection, sortedFilteredJobRefs, filteredOverviewAttributes, waitingForInitialJobData, numHiddenJobs)',
      '_updateModelListeners(selectedModel, signedIn)'
    ];
  }

  constructor() {
    super();

    this.enabledFeatures = {};
    this.companies = {};
    this.attacherList = {};
    this.serverUtilityModels = {};
    this.signedIn = false;
    this.userCanRead = false;
    this.userGroup = null;
    this.serverId = config.appName;
    this.modelOwner = null;
    this.selectedModel = null;
    this.sortedFilteredJobRefs = [];
    this.modelOptions = [];
    this.isPortalServer = config.firebaseConfigs[config.appName].isPortalServer;
    this.pageTitle = `${config.serverNames[config.appName]} ${this.isPortalServer ? 'Pole Applications' : 'Overview'}`;
    this.gettingStartedLink = this._getGettingStartedLink(config.appName);
    this.showAllWorkflowsVisibleButton = false;
    this.allWorkflowsVisible = false;
    this.userCanWrite = false;
    this.createButtonDisabled = true;

    this.originIsDev = checkIsDevelopmentOrigin();
    this.getSyncedModelsDescription = (syncedModels) =>
      `Also showing jobs with these models: ${syncedModels?.map((model) => this.companies?.[model].name ?? model).join(', ')}`;

    this.initOverviewWorker();
  }

  connectedCallback() {
    super.connectedCallback();

    this.kpiMilestonePortalExportFlagListener = addFlagListener('kpi_milestone_portal_export', (enabled) => {
      this.set('enabledFeatures.kpi_milestone_portal_export', enabled);
    });
    this.costCauserSplitsPortalExportFlagListener = addFlagListener('cost_causer_splits_portal_export', (enabled) => {
      this.set('enabledFeatures.cost_causer_splits_portal_export', enabled);
    });
    this.costCauserSplitsPortalExportFlagListener = addFlagListener('ppl_preconstruction_portal_export', (enabled) => {
      this.set('enabledFeatures.ppl_preconstruction_portal_export', enabled);
    });

    const authService = firebase.auth();
    this.authStateListenerUnsubscribe = authService.onIdTokenChanged(async (user) => {
      const userId = user?.uid;
      const userGroup = (await user?.getIdTokenResult())?.claims?.userGroup;

      // Unsubscribe from previous roles listeners.
      this.rolesListeners?.forEach((unsubscribeListener) => unsubscribeListener());

      // Don't set up new listeners without user id or user group.
      if (!userId || !userGroup) return;

      // Set up new roles listeners.
      this.rolesListeners = [
        ListenToUserRole(userId, 'application_manager', userGroup, (userIsAppManager) => (this.userIsAppManager = userIsAppManager))
      ];
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    clearInterval(this.resizeInterval);

    removeFlagListener('kpi_milestone_portal_export', this.kpiMilestonePortalExportFlagListener);
    removeFlagListener('cost_causer_splits_portal_export', this.costCauserSplitsPortalExportFlagListener);
    removeFlagListener('ppl_preconstruction_portal_export', this.pplPreconstructionPortalExportFlagListener);

    this.disconnectPortalConfigListener?.();

    this.authStateListenerUnsubscribe?.();
    this.rolesListeners?.forEach((unsubscribeListener) => unsubscribeListener());
    this._unsubscribeModelOwner?.();
    this._unsubscribeCompanyAttributes?.();
    this._unsubscribeAttachmentTypes?.();
  }

  ready() {
    zip.workerScriptsPath = '../_resources/js/open-source/zipjs/';

    super.ready();

    new AppConfiguration(this);

    this.serverUtilityCompany = config.firebaseConfigs[config.appName].utilityCompany;

    this.calcComputedOverviewAttribute = calcComputedOverviewAttribute.bind(this);

    adoptStyles(this.shadowRoot, [lightTheme]);
  }

  _getGettingStartedLink(projectId) {
    switch (projectId) {
      case 'ppl-kws':
        return '../pole-application-getting-started/';
      case 'lge-ku-pole-applications':
        return 'https://lge-ku.com/pole-attachment-services';
      default:
        return null;
    }
  }

  initOverviewWorker() {
    if (this.overviewWorker) return;
    const workerURL = new URL('./worker-functions/OverviewWorker.js', import.meta.url);
    const worker = new Worker(workerURL, { type: 'module' });
    Comlink.expose(
      {
        jobDataHandler: this.handleFilteredJobDataFromWorker.bind(this),
        jobDataFetchProgressHandler: this.handleFetchJobDataProgressFromWorker.bind(this)
      },
      worker
    );
    this.overviewWorker = Comlink.wrap(worker);

    const firebaseConfig = globalThis.config.firebaseConfigs[globalThis.config.appName];
    this.overviewWorker.initializeFirebase(firebaseConfig);
  }

  handleFetchJobDataProgressFromWorker(data) {
    const { progress } = data;

    if (progress == 0) {
      this.waitingForInitialJobData = true;
    } else if (progress == 1) {
      this.waitingForInitialJobData = false;
    }

    const progressBar = this.shadowRoot?.getElementById('jobLoadingProgress');
    if (progressBar instanceof SlProgressBar) {
      progressBar.indeterminate = progress == 0;
      progressBar.value = progress * 100;

      if (progress == 1) {
        clearTimeout(this._showProgressBarTimeout);
        this._showProgressBarTimeout = null;
        this._hideProgressBarTimeout ??= setTimeout(() => {
          progressBar.style.visibility = 'hidden';
        }, 200);
      } else {
        clearTimeout(this._hideProgressBarTimeout);
        this._hideProgressBarTimeout = null;
        this._showProgressBarTimeout ??= setTimeout(() => {
          progressBar.style.visibility = 'visible';
        }, 200);
      }
    }
  }

  handleFilteredJobDataFromWorker(data) {
    const { sortedFilteredJobRefs, numDrafts, numHiddenJobs } = data;

    // Build a status color lookup
    const statusColorLookup = {};
    const workflowEntries = Object.entries(this.portalConfig?.app_types ?? {});
    for (const [workflowId, workflow] of workflowEntries) {
      statusColorLookup[workflowId] = {};
      for (const status of Object.values(workflow.statuses ?? {})) {
        statusColorLookup[workflowId][status.name] = status.color;
      }
    }

    sortedFilteredJobRefs.forEach((jobRef) => {
      if (jobRef.isJob) {
        const existingJobRef = this.sortedFilteredJobRefs?.find((x) => x.key == jobRef.key);
        jobRef.$display = existingJobRef?.$display || {
          animateExpand: false,
          rowExpanded: false,
          showCollapseContent: false
        };
        jobRef.$display.filterRowExpanded = jobRef.expand ?? false;

        // Add value to each overview attribute
        jobRef.$overviewAttributes = this.filteredOverviewAttributes?.map((x) => {
          const value = getColumnValue(x.attribute, { job: jobRef.$job, appTypesConfig: this.portalConfig?.app_types });
          return { ...x, $value: value };
        });

        // Add status color to each item
        jobRef.$statusColor = statusColorLookup[jobRef.$job.metadata?.app_type]?.[jobRef.$job.metadata?.app_status];
      }
    });

    this.filteringJobs = false;
    if (sortedFilteredJobRefs.length) this.waitingForInitialJobData = false;

    // Add draft row to temp.
    const shouldShowDraftRow = !this.showDrafts && numDrafts > 0;
    if (shouldShowDraftRow) sortedFilteredJobRefs.unshift({ show_drafts: true });

    Object.assign(this, { sortedFilteredJobRefs, numDrafts, numHiddenJobs });

    // Update row expand data for each entry
    this.sortedFilteredJobRefs.forEach((x, i) => this.updateAppRowExpanded(i));
  }

  ironListScroll(e) {
    const scrollTop = e.currentTarget.scrollTop;
    if (scrollTop !== this.ironListScrollTop) {
      if (scrollTop > 0 || Math.abs(scrollTop - this.ironListScrollTop) < 50) this.ironListScrollTop = scrollTop;
      else e.currentTarget.scrollTop = this.ironListScrollTop;
    }
  }

  appNameContains(appName, searchString) {
    return (appName || '').toLowerCase().indexOf(searchString.toLowerCase()) != -1;
  }

  setStartingModel() {
    // If a model is already selected, do not change it.
    if (this.selectedModel != null) return;
    // If the user is not signed in, or there are no models to select, do not set a model.
    if (!this.signedIn || !Array.isArray(this.modelsForSelection)) return;

    // Always prefer a model stored in local storage.
    const modelFromLocalStorage = localStorage.getItem('selectedModel');
    if (modelFromLocalStorage) {
      this.selectedModel = modelFromLocalStorage;
      return;
    }

    // Otherwise select the first model in the list.
    this.selectedModel = this.modelsForSelection[0]?.value;
  }

  getWorkflowVisibilityFromLocalStorage() {
    const modelId = this.selectedModel;
    const localStoragePath = `overview_page_visible_workflows/${modelId}`;
    try {
      return JSON.parse(localStorage.getItem(localStoragePath) ?? '');
    } catch (err) {
      return null;
    }
  }

  updateWorkflowVisibility() {
    const workflowVisibility = [];
    const workflowVisibilityFromLocalStorage = this.getWorkflowVisibilityFromLocalStorage();

    const addWorkflow = (workflowId, visibleByDefault = false) => {
      const localStorageVisible = workflowVisibilityFromLocalStorage?.[workflowId];
      const visible = localStorageVisible != null ? localStorageVisible === true : visibleByDefault;
      workflowVisibility.push({ workflowId, visible: visible });
    };

    const workflowIds = Object.keys(this.portalConfig?.app_types ?? {});
    workflowIds.forEach((workflowId) => addWorkflow(workflowId, true));

    // Determine if all workflows are visible
    const showAllWorkflowsVisibleButton = workflowVisibility.length > 1;
    const allWorkflowsVisible = workflowVisibility.every((x) => x.visible);

    // Add a catch-all option for displaying jobs without a workflow.
    addWorkflow('_NO_WORKFLOW');

    Object.assign(this, { workflowVisibility, showAllWorkflowsVisibleButton, allWorkflowsVisible });
  }

  calcCreateAppTypes() {
    // Get an array of app types from the master config object
    const appTypesList = Object.entries(this.portalConfig?.app_types ?? {}).map(([$key, x]) => ({ ...x, $key }));
    // Bail if there are no app types
    if (!appTypesList?.length) return;

    const isReviewContractor = Boolean(this.portalConfig?.user_options?.review_contractors?.[this.userGroup]);
    const hasOwnerPermission = this.userGroup === this.selectedModel || this.userGroup === this.modelOwner || isReviewContractor;

    // Filter the app types to those visible to the user
    this.createAppTypes = appTypesList.filter((appType) => !appType.utility_create_only || hasOwnerPermission);
  }

  attributeClickHandler(e) {
    const { attr, item: jobRef } = e.model ?? {};
    const { on_click: onClick } = attr ?? {};
    const { key: jobId, $job: jobData } = jobRef ?? {};
    if (!jobId) return;
    const { metadata } = jobData ?? {};
    if (onClick === 'editAppTimeline') {
      this.timelineEditJobId = jobId;
      this._timelineMetadataUpdate = null;
      this.$.editTimelineDialog.open();
    } else if (onClick === 'toggle') {
      let update = {};
      update[`metadata/${attr.attribute}`] = !Path.get(metadata, attr.attribute);
      globalThis.FirebaseWorker.ref(`photoheight/jobs/${jobId}`).update(update);
      UpdateJobPermissions(jobId, this.userGroup, update, {
        fetchSharedCompanies: true
      });
    }
  }

  attributeDoubleClickHandler(e) {
    if (Path.get(e, 'model.attr.on_click')) {
      preventDefault(e);
    }
  }

  appExpandTransitionChanged(e) {
    const jobRefDisplayPath = `sortedFilteredJobRefs.${e.model.index}.$display`;
    const jobRefDisplay = this.get(jobRefDisplayPath) ?? {};
    // If transitioning is stopped (not starting) and rowExpanded has been initialized.
    if (!e.detail.value && jobRefDisplay.rowExpanded != null) {
      // When not transitioning (done), turn animation off.
      if (jobRefDisplay.animateExpand) this.set(`${jobRefDisplayPath}.animateExpand`, false);
      // When transitioning stops, if the collapse is closed, hide the content.
      if (!jobRefDisplay.rowExpanded) this.set(`${jobRefDisplayPath}.showCollapseContent`, false);
    }
  }

  getHighlightFilters(searchString, overviewAttribute) {
    // Split the search string by spaces
    let searchTerms = searchString?.split(' ') ?? [];
    let filterValue = this.filterAttributeValues[overviewAttribute.attribute];

    if (!overviewAttribute) return searchTerms;

    // Get additional search terms by variable type
    let attributeType = overviewAttribute.type;
    if (attributeType == 'date') {
      let dateFilterValues = Object.values(filterValue ?? {});
      searchTerms.push(...dateFilterValues.map((x) => this.formatDate(x)));
    } else if (attributeType == 'company') searchTerms.push(this.getCompanyName(filterValue, overviewAttribute.attribute));
    else searchTerms.push(filterValue);

    // Return the search terms
    return searchTerms.filter((x) => !!x);
  }

  closeEditTimelineDialog(e) {
    // Determine close action
    let action = e.currentTarget.dataset.action;

    // If the action is save, save the data to firebase
    if (action == 'save') {
      // Make the update object flat
      let update = Path.flattenObject(this._timelineMetadataUpdate, '/');

      // Commit the update in firebase
      if (Object.keys(update).length) {
        FirebaseWorker.ref(`photoheight/jobs/${this.timelineEditJobId}`).update(update);
        UpdateJobPermissions(this.timelineEditJobId, this.userGroup, update, { fetchSharedCompanies: true });
      }
    }

    // Clear the change buffer
    this._timelineMetadataUpdate = null;
    // Clear the timeline editor's selected model key
    this.$.appTimelineEditor.selectedModelKey = null;
  }

  calcFilteredOverviewAttributes(portalConfig, userGroup, selectedModel, modelOwner, companyAttributes) {
    // Skip if we don't have the data we need
    if (!companyAttributes || !userGroup || Object.keys(portalConfig ?? {}).length == 0) return;

    // Get the contractors from the portal config
    const reviewContractors = this.portalConfig.user_options?.review_contractors ?? {};
    const engineeringContractors = this.portalConfig.user_options?.engineering_contractors ?? {};
    const dataCollectionContractors = this.portalConfig.user_options?.data_collection_contractors ?? {};

    // Determine the role of this user.
    const isOwner = userGroup === selectedModel || userGroup === modelOwner;
    const isReviewContractor = Boolean(reviewContractors[userGroup]);
    const isEngineeringContractor = Boolean(engineeringContractors[userGroup]);
    const isDataCollectionContractor = Boolean(dataCollectionContractors[userGroup]);

    // Sort and filter the overview attributes list (use the default list if there are none)
    const overviewAttributes = this.portalConfig?.display_options?.overview_attributes ?? DEFAULT_OVERVIEW_ATTRIBUTES;
    const overviewAttributesList = Object.entries(overviewAttributes).map(([$key, attribute]) => ({ ...attribute, $key }));
    const sortedOverviewAttributes = overviewAttributesList.sort((a, b) => a.order - b.order);
    const filteredOverviewAttributes = sortedOverviewAttributes.filter((x) => {
      if (!x.limit_visibility) return true;
      if (x.visibility == null) return false;
      return (
        (x.visibility.utility_company && isOwner) ||
        (x.visibility.review_contractors && isReviewContractor) ||
        (x.visibility.engineering_contractors && isEngineeringContractor) ||
        (x.visibility.data_collection_contractors && isDataCollectionContractor)
      );
    });

    // Return the list with models
    this.filteredOverviewAttributes = filteredOverviewAttributes.map((x) => ({ ...x, $model: companyAttributes[x.attribute] }));
  }

  calcPortalAppStatuses() {
    const appTypes = Object.entries(this.portalConfig?.app_types ?? {}).map(([$key, appType]) => ({ ...appType, $key }));

    // Collapse statuses with the same name across app types into a single entry. A status shared by multiple app types appears once in the list
    const statusesByKey = new Map();
    for (const appType of appTypes) {
      const appTypeStatuses = Object.values(appType.statuses ?? {}).sort((a, b) => a.status?.localeCompare?.(b.status));
      for (const x of appTypeStatuses) {
        if (x.name == null) continue;
        const status = String(x.name).trim();
        if (!status) continue;
        const key = status.toLowerCase();
        if (!statusesByKey.has(key)) {
          // Add status to list if not there already
          statusesByKey.set(key, { status, appTypes: new Set(), order: statusesByKey.size });
        }
        const appTypeName = String(appType.display_name ?? 'Unknown Application').trim();
        if (appTypeName) statusesByKey.get(key).appTypes.add(appTypeName); // Add the app type to the matching status entry if it already exists
      }
    }

    return Array.from(statusesByKey.values()).map(({ status, appTypes, order }) => ({
      status,
      appType: Array.from(appTypes).join(', '),
      order
    }));
  }

  getTotalJobCount(sortedFilteredJobRefs = [], numHiddenJobs = 0) {
    return sortedFilteredJobRefs.filter((x) => !x?.show_drafts).length + (numHiddenJobs ?? 0);
  }

  getTotalDraftCount(showDrafts, numDrafts) {
    if (showDrafts === true) return 0;
    return numDrafts ?? 0;
  }

  async updateOverviewWorkerJobFilterOptions() {
    if (!this.selectedModel || !this.signedIn || !this.filteredOverviewAttributes || !this.overviewWorker) return;

    // Get data objects for sort, filter, and expand
    const filterData = {
      searchString: this.searchString,
      filterAttributeValues: this.filterAttributeValues,
      workflowVisibility: this.workflowVisibility,
      showDuplicated: this.showDuplicated,
      showCompletedApps: this.showCompletedApps,
      showDrafts: this.showDrafts,
      numJobsToShow: this.numJobsToShow
    };
    const sortData = {
      sortAttr: this.sortAttr,
      sortReverse: this.sortReverse
    };
    const configData = {
      filteredOverviewAttributes: this.filteredOverviewAttributes,
      limitJobChooser: this.jobChooserOptions?.limit_job_chooser ?? {},
      portalUserOptions: this.portalConfig?.user_options ?? {},
      appTypesConfig: this.portalConfig?.app_types ?? {},
      model: this.selectedModel,
      userGroup: this.userGroup,
      systemAdmin: this.systemAdmin,
      userIsAdmin: katapultAuth.admin,
      userUid: katapultAuth.user.uid,
      models: [this.selectedModel],
      modelOwner: this.modelOwner
    };

    // Start loading animation.
    this.filteringJobs = true;
    this.overviewWorker.setJobFilterOptions({ filterData, sortData, configData });
  }

  updateOverviewWorkerIncludeArchived() {
    if (!this.overviewWorker) return;
    this.overviewWorker.setIncludeArchived(this.showArchived === true);
  }

  collapseContentChanged(e) {
    const domIfDisplayingContent = e.currentTarget.if;
    const jobRefDisplayPath = `sortedFilteredJobRefs.${e.model.index}.$display`;
    const jobRefDisplay = this.get(jobRefDisplayPath) ?? {};
    // If content is being displayed and rowExpanded has been initialized, expand the row.
    if (domIfDisplayingContent && jobRefDisplay.rowExpanded != null) {
      setTimeout(() => {
        this.set(`sortedFilteredJobRefs.${e.model.index}.$display.animateExpand`, true);
        this.set(`sortedFilteredJobRefs.${e.model.index}.$display.rowExpanded`, true);
        // Notify start iron list update loop.
        const ironList = this.shadowRoot?.querySelector('#appList');
        NotifyResizable('poleAppOverview', ironList, 400);
      });
    }
  }

  async createApplication(e) {
    this.$$('#createMenu').close();
    this.$$('#createButton').loading = true;
    this.createButtonText = 'Creating';

    // Get the app type and job model.
    const appType = e.model.item.$key;
    const newJobModel = this.selectedModel;

    if (newJobModel) {
      // Create the draft.
      const { jobId } = await createWorkflowJob(newJobModel, appType, {}, { userRecord: globalThis.katapultAuth.userRecord });
      const jobName = await KatapultJob.fromId(jobId).getName();

      // Get a url to the new app.
      const url = this.getAppUrl(jobId);

      // Open the job in a new tab
      this.createButtonText = 'Opening';
      window.open(url, '_blank');

      // Show a toast notification with a link to the new app
      // Follows example from https://shoelace.style/components/alert/#creating-toasts-imperatively
      const alertElement = Object.assign(document.createElement('sl-alert'), { variant: 'primary', closable: true, duration: 5000 });
      const html = litHtml;
      render(
        html`
          <katapult-icon slot="icon" icon="check_circle" style="color: var(--sl-color-primary);"></katapult-icon>
          <span>Created <b>${jobName}</b>. Didn't open automatically?</span>
          <a href=${url} target="_blank" style="text-decoration: none; color: var(--sl-color-primary);">
            Open in new tab
            <katapult-icon icon="open_in_new" size="small" style="display: inline-block; vertical-align: text-bottom;"></katapult-icon>
          </a>
        `,
        alertElement
      );
      document.body.appendChild(alertElement);
      alertElement.toast();
    }

    this.$$('#createButton').loading = false;
    this.createButtonText = 'Create';
  }

  getWorkflowLabel(workflowId, plural = false) {
    if (workflowId === '_NO_WORKFLOW') return 'Jobs without a Workflow';

    const { display_name: displayName } = this.portalConfig.app_types?.[workflowId] ?? {};
    const label = displayName || workflowId;
    if (!label) return '';
    return plural ? pluralize(label) : label;
  }

  getWorkflowVisibilitySummary() {
    const { workflowVisibility } = this;

    const visibleOptions = workflowVisibility?.filter((x) => x.visible) ?? [];
    const numVisibleOptions = visibleOptions.length;

    const showingNoWorkflow = visibleOptions.some((x) => x.workflowId === '_NO_WORKFLOW');
    const genericOptionName = showingNoWorkflow ? 'Option' : 'Workflow';

    if (numVisibleOptions === 0) return 'Select a Workflow...';
    if (numVisibleOptions === 1) return `Showing ${this.getWorkflowLabel(visibleOptions[0].workflowId, true)}`;
    return `Showing ${numVisibleOptions} ${pluralize(genericOptionName, numVisibleOptions)}`;
  }

  setAllWorkflowVisibility(newVisibility) {
    if (!this.selectedModel) return;
    const relevantWorkflows = this.workflowVisibility.filter((x) => x.workflowId !== '_NO_WORKFLOW');
    relevantWorkflows.forEach((item) => this.setWorkflowVisibility(item.workflowId, newVisibility));
    this.updateWorkflowVisibility();
  }

  toggleWorkflowVisibility(e) {
    const { item } = e?.detail ?? {};
    const { checked: visible = false, value: workflowId } = item;
    if (!workflowId || !this.selectedModel) return;

    if (workflowId === '_ALL_WORKFLOWS') {
      this.setAllWorkflowVisibility(visible);
      return;
    }

    this.setWorkflowVisibility(workflowId, visible);
    this.updateWorkflowVisibility();
  }

  setWorkflowVisibility(workflowId, visible) {
    const modelId = this.selectedModel;
    const localStoragePath = `overview_page_visible_workflows/${modelId}`;
    const workflowVisibilityFromLocalStorage = this.getWorkflowVisibilityFromLocalStorage() ?? {};
    workflowVisibilityFromLocalStorage[workflowId] = visible;
    localStorage.setItem(localStoragePath, JSON.stringify(workflowVisibilityFromLocalStorage));
  }

  // TODO (2024-01-09): The following functions will someday be replaced by a better attacher manager
  // ----------------------------------------------------------------------------------
  toggleCollapse(e) {
    this.shadowRoot.querySelector('#' + e.currentTarget.getAttribute('name')).toggle();
    var count = 0;
    this.resizeInterval = setInterval(() => {
      count += 16;
      this.shadowRoot.querySelector('#regionalAdminDialog').notifyResize();
      if (count >= 400) clearInterval(this.resizeInterval);
    }, 16);
  }

  editAttacher(e) {
    if (this.editingAttacher != null) {
      this.shadowRoot.querySelector('#edit' + this.editingAttacher).value = this.get('attachers.' + this.editingAttacher + '.name');
    }
    this.editingAttacher = e.model.item.$key;
    e.currentTarget.parentNode.focus();
  }

  editAttacherAddClose() {
    this.showAddAttacher = false;
  }

  editAttacherAddOpen() {
    this.showAddAttacher = true;
    setTimeout(() => {
      this.shadowRoot.querySelector('#newAttacher').focus();
    });
  }

  editAttacherCancel(e) {
    e.currentTarget.parentNode.value = this.get('attachers.' + e.model.item.$key + '.name');
    this.editingAttacher = null;
  }

  editAttacherSave(e) {
    var name = e.currentTarget.parentNode.value;
    var id = this.editingAttacher;
    var update = {};
    if (e.currentTarget.parentNode.id == 'newAttacher') {
      // Get a unique key
      id = name
        .toLowerCase()
        .replace(/[\.,()+:\-\[\]\$\#\/]+/g, '')
        .replace(/[ _]+/g, '_');
      let largestNumber = 0;
      let foundMatch = false;
      for (var key in this.attachers) {
        if (key.indexOf(id) == 0) {
          foundMatch = true;
          let match = key.match(/\d+$/g);
          if (match != null) {
            match = parseInt(match[0]);
            if (match > largestNumber) {
              largestNumber = match;
            }
          }
        }
      }
      if (foundMatch) {
        id += largestNumber + 1;
      }
    } else if (this.companies[id]) {
      update['photoheight/companies/' + id + '/name'] = name;
      update['photoheight/company_space/' + id + '/name'] = name;
    }
    update['utility_info/' + this.selectedModel + '/attachers/' + id + '/name'] = name;
    FirebaseWorker.ref()
      .update(update)
      .then(() => {
        this.$.toast.show('Company Updated');
      })
      .catch((err) => {
        this.$.toast.show(err.message);
      });
    this.editingAttacher = null;
    this.showAddAttacher = false;
    this.newAttacherName = '';
  }
  // ----------------------------------------------------------------------------------

  async export(e) {
    if (!this.overviewWorker) return;

    // Get the export type from the element's dataset
    const exportType = e.currentTarget.dataset.exportType;
    const exportKey = exportType.replaceAll(' ', '_').toLowerCase();

    const allSortedFilteredJobRefs = await this.overviewWorker.getAllSortedJobs();
    const jobSummary = await this.overviewWorker.getJobData();

    // Base data config for appExport
    let dataConfig = {
      jobs: allSortedFilteredJobRefs.map((x) => x.key).filter((x) => x),
      jobSummary,
      companyAttributes: this.companyAttributes,
      companies: this.companies,
      attachers: this.attachers,
      overviewAttributes: this.filteredOverviewAttributes,
      poleAttributes: Object.values(this.portalConfig.app_types).map((x) => x.pole_attributes),
      attachmentTypes: this.attachmentTypes,
      color: config.firebaseData.palette.secondaryColor ?? '#000000',
      isUtility: this.userGroup === this.selectedModel,
      userGroup: this.userGroup,
      utilityCompany: this.selectedModel,
      fileName: `${exportType} Export`,
      isNon3PA: !this.is3PAPortalModel
    };

    if (exportKey == 'kpi_milestones' || exportKey == 'cost_causer_splits') {
      dataConfig.skipLoadingJobData = true;
      let jobNames = allSortedFilteredJobRefs
        .map((x) => x.jobName)
        .filter((x) => x)
        .join(', ');
      let canceled = false;
      const dialog = KatapultDialog.open({
        dialog: { title: 'Apps To Export', modal: true, maxWidth: 600 },
        template: () => litHtml`
          <div>The following applications will be exported with the following name. You may edit the list before proceeding.</div>
          <paper-input id="exportName" value="${exportType} Export ${DateTime.now().toISODate()}"></paper-input>
          <paper-textarea value="${jobNames}" label="" no-label-float></paper-textarea>
          <katapult-button id="cancel" slot="buttons" dialog-dismiss>Cancel</katapult-button>
          <katapult-button id="confirm" slot="buttons" color="var(--secondary-color)">Export</katapult-button>
        `
      });
      await dialog.openStart;
      dialog.querySelector('#cancel').addEventListener('click', () => (canceled = true));
      dialog.querySelector('#confirm').addEventListener('click', () => {
        jobNames = dialog.querySelector('paper-textarea').value.split(',');
        const jobNameLookup = {};
        for (const jobId in jobSummary) {
          jobNameLookup[jobSummary[jobId]?.name] = jobId;
        }
        dataConfig.jobs = jobNames.map((name) => jobNameLookup[name.trim()]).filter((x) => x);
        dataConfig.fileName = dialog.querySelector('#exportName').value ?? `${exportType} Export`;
        dialog.close();
      });
      await dialog.closeStart;
      if (canceled) return;
      await import('../katapult-maps-desktop/exports/excel-exports.js');
    }

    this.set(`runningExports.${exportKey}`, { isRunning: true, progress: 0 });
    const updateProgress = (newVal) => this.set(`runningExports.${exportKey}.progress`, newVal);

    // Open the export menu if it's been closed from clicking on another dialog window
    this.shadowRoot.querySelector('#exportMenu').open();

    // Get the data for the export
    const data = await AppExport.export(
      dataConfig,
      { firebase: firebase, formatDate: FormatDate, updateProgress, excelExports: this.$.excelExports },
      { type: exportType }
    );

    // If the export is a KMZ export
    if (exportType === 'KMZ') {
      zip.createWriter(new zip.BlobWriter(), function (writer) {
        writer.add('pole_export.kml', new zip.TextReader(data), () => {
          writer.close((blob) => Download(blob, `${exportType} Export.kmz`));
        });
      });
    }
    // If the export is Cost Causer Splits, we need to do two versions of the same export
    else if (exportType === 'Cost Causer Splits') {
      const { byAppData, byInvoiceData } = data;
      const byAppFileName = dataConfig.fileName?.replace('Splits', 'Splits by App');
      Download(byAppData, `${byAppFileName}.csv`, 'text/csv');
      const byInvoiceFileName = dataConfig.fileName?.replace('Splits', 'Splits by Invoice');
      Download(byInvoiceData, `${byInvoiceFileName}.csv`, 'text/csv');
    } else if (typeof data == 'object' && data.fileURL) {
      window.open(data.fileURL);
    } else if (typeof data == 'object' && data.error) {
      this.$.toast.show(data.error);
    }

    // Otherwise, download the data as-is
    else Download(data, `${dataConfig.fileName}.csv`, 'text/csv');

    this.set(`runningExports.${exportKey}`, { isRunning: false, progress: 0 });
  }

  importTimeline() {
    this.shadowRoot.querySelector('#importTimelineInput').click();
  }

  getAppUrl(appId) {
    if (this.is3PAPortalModel) return `../pole-application/#${appId}`;
    return `../map/#${appId}`;
  }

  getAttributeName(item) {
    if (item) return item.label || this.get(`companyAttributes.${item.attribute}.label`) || CamelCase(item.attribute);
  }

  getAttributeStyle(metadata, overviewAttribute) {
    if (!metadata) return;
    const styles = [];

    const styleConfigs = {
      error: ['background-color: var(--paper-red-100);', 'color: var(--paper-red-900);'],
      warning: ['background-color: var(--paper-amber-100);', 'color: var(--paper-amber-900);']
    };

    switch (overviewAttribute.attribute) {
      case 'timeline_progress': {
        const { daysRemaining } = getTimelineProgress(metadata) ?? {};
        if (daysRemaining != null && daysRemaining < 0) styles.push(...styleConfigs.error);
        else if (daysRemaining != null && daysRemaining < 7) styles.push(...styleConfigs.warning);
        break;
      }
      case 'days_left_in_stage': {
        const { daysRemaining } = getActiveTimelineStageProgress(metadata) ?? {};
        if (daysRemaining != null && daysRemaining < 0) styles.push(...styleConfigs.error);
        else if (daysRemaining != null && daysRemaining < 7) styles.push(...styleConfigs.warning);
      }
    }

    // May not be used anymore...
    if (overviewAttribute.flex_grow) styles.push(`flex-grow: ${overviewAttribute.flex_grow};`);

    return styles.join(' ');
  }

  getCompanyName(key, attr) {
    if (attr == 'attachment_owner') return this.get(`attachers.${key}.name`);
    else return this.get(`companies.${key}.name`);
  }

  formatDate(time) {
    return time ? FormatDate(parseInt(time)) : '';
  }

  formatTimelineDate(stageStartDate) {
    return stageStartDate ? this.formatDate(this.timelineEditMetadata[stageStartDate]) : '';
  }

  hideFilters() {
    const element = this.shadowRoot?.querySelector('app-filter-input');
    if (element) element.showAdvancedFilters = false;
  }

  isPlainTextOverviewCell(attr) {
    return !attr?.display_as && attr?.attribute != 'action_buttons';
  }

  updateSortAttribute(e) {
    if (e.model.overviewAttribute.attribute == 'action_buttons') return;
    // If the sort attribute is not the clicked header, set it to the clicked header and set the sort to be ascending
    if (this.sortAttr != e.model.overviewAttribute.attribute) {
      this.sortAttr = e.model.overviewAttribute.attribute;
      this.sortReverse = false;
      return;
    }

    // If the clicked header is the current sort attribute and the sort is ascending, set the sort to be descending
    if (this.sortReverse == false && this.sortAttr == e.model.overviewAttribute.attribute) {
      this.sortReverse = true;
      return;
    }

    // Otherwise, clear the sort attribute
    this.sortAttr = null;
  }

  async importTimelineInputChanged(e) {
    // Calc number of milliseconds per day.
    let millisPerDay = 1000 * 60 * 60 * 24;
    // Store a reference to the file.
    let file = e.target.files[0];
    // Clear the file input.
    e.target.value = null;
    // Lazyload papaparse.
    let Papa = (await import('papaparse')).Papa;
    // Parse the csv.
    Papa.parse(file, {
      header: true,
      transformHeader: (str) => SnakeCase(str)?.toLowerCase(),
      complete: async (res) => {
        let numValid = 0;
        let numInvalid = 0;
        let update = {};
        for (let job of res.data) {
          if (job.job_id) {
            // Convert the due date to a date object.
            let dueDate = new Date(job.set_due_date_for_survey_upload_required);
            dueDate.setHours(0, 0, 0, 0);
            // Check that the new due date is valid (it won't be if a due date wasn't supplied).
            if (!isNaN(dueDate.getTime())) {
              let startDate = new Date(job.survey_start_date);
              startDate.setHours(0, 0, 0, 0);
              let duration = Math.floor((dueDate.getTime() - startDate.getTime()) / millisPerDay);
              if (!isNaN(startDate.getTime()) && duration != null) {
                numValid++;
                // Update the survey length on the job's timeline.
                update[`photoheight/jobs/${job.job_id}/metadata/timeline/stages/0/length`] = duration;
                // Update the survey length in job_permissions as well.
                await UpdateJobPermissions(
                  job.job_id,
                  this.userGroup,
                  { 'metadata/timeline/stages/0/length': duration },
                  { fetchSharedCompanies: true, update }
                );
              } else {
                numInvalid++;
              }
            } else {
              numInvalid++;
            }
          }
        }
        await FirebaseWorker.ref().update(update);
        this.$.toast.show({
          text: `${numInvalid} jobs skipped due to missing or invalid timeline or due date. ${numValid} jobs updated.`,
          duration: 5000
        });
      }
    });
  }

  selectedModelChanged(selectedModel) {
    // Save the model in local storage if it exists
    if (selectedModel != null) localStorage.setItem('selectedModel', selectedModel);
    // Load the portal config for the selected model
    this.updatePortalConfigListener(selectedModel);
    // Reset draft and hidden job counts.
    this.showDrafts = false;
    this.numJobsToShow = 100;
  }

  updatePortalConfigListener(selectedModel) {
    this.disconnectPortalConfigListener?.();

    if (!selectedModel) return;

    const ref = globalThis.FirebaseWorker.ref(`photoheight/company_space/${selectedModel}/portal_config`);
    const callback = (snapshot) => {
      this.portalConfig = snapshot.val();
      this.portalConfigLoaded = true;
    };
    ref.on('value', callback);

    this.disconnectPortalConfigListener = () => {
      ref.off('value', callback);
      this.portalConfig = null;
      this.portalConfigLoaded = false;
      this.disconnectPortalConfigListener = null;
    };
  }

  logOverviewLoaded() {
    if (this.user?.uid) {
      const logObject = {
        uid: this.user.uid,
        timestamp: firebase.database.ServerValue.TIMESTAMP,
        desc: `Pole Overview loaded by ${this.user.email}`
      };
      FirebaseWorker.ref('photoheight/logs').push(logObject);
    }
  }

  openApp(e) {
    window.open(this.getAppUrl(e.currentTarget.key));
  }

  openRegionalAdminDialog(e) {
    this.shadowRoot.querySelector('#regionalAdminDialog').open();
  }

  stopPropagation(e) {
    e.stopPropagation();
  }

  setDefaultSortAttribute(default_sort_attribute) {
    if (default_sort_attribute) {
      this.sortAttr = default_sort_attribute;
    }
  }

  showCreateButton(approvedToSubmit, allowCreateBeforeApproved) {
    return approvedToSubmit || allowCreateBeforeApproved;
  }

  toggleAppRow(e) {
    this.set(
      `sortedFilteredJobRefs.${e.model.index}.$display.userRowExpanded`,
      !this.sortedFilteredJobRefs?.[e.model.index]?.$display?.userRowExpanded
    );
    this.updateAppRowExpanded(e.model.index);
  }

  updateApprovedToSubmit() {
    this.approvedToSubmitDebounce = Debouncer.debounce(this.approvedToSubmitDebounce, timeOut.after(100), async () => {
      if (!this.signedIn || !this.userGroup) return;

      let pendingCompany = null;
      if (!this.userCanRead) {
        const companyName = (await globalThis.FirebaseWorker.ref(`photoheight/companies/${this.userGroup}/name`).once('value')).val();
        this.approvedToSubmit = false;
        pendingCompany = true;
        this.pendingApprovalText = `You must be approved to join ${companyName} before you can create applications`;
      } else {
        this.approvedToSubmit = this.getCompanyApprovedToSubmit(
          this.userGroup,
          this.selectedModel,
          this.modelOwner,
          this.is3PAPortalModel,
          this.attacherList
        );

        if (!this.approvedToSubmit) {
          pendingCompany = Object.values(this.attacherList ?? {}).find((company) => company.pending || company.pending_join_company);
          if (pendingCompany) {
            if (pendingCompany.pending) {
              if (pendingCompany.$key === this.userGroup) {
                const serverName = config.firebaseData.name || 'the server owner';
                this.pendingApprovalText = `Your company, ${pendingCompany.name}, must be approved by ${serverName} before you can create applications`;
              } else this.pendingApprovalText = `You must be approved by ${pendingCompany.name} before you can create applications`;
            } else if (pendingCompany.pending_join_company)
              this.pendingApprovalText = `You must be approved to join ${pendingCompany.name} before you can create applications`;
          }
        }
      }
      const reviewContractors = Object.keys(this.portalConfig?.user_options?.review_contractors ?? {});

      const missingApproval = !this.approvedToSubmit && (!this.attacherListLoading || !this.userCanRead);

      this.$.notApprovedDialog.opened = missingApproval && pendingCompany;
      this.$.needToRequestDialog.opened = missingApproval && !pendingCompany && !reviewContractors.includes(this.userGroup);
    });
  }

  getCompanyApprovedToSubmit(companyId, selectedModel, modelOwner, is3PAPortalModel, attacherList) {
    // For non-3PA portal models, anyone with access to the model can create jobs.
    if (!is3PAPortalModel) return true;

    // For 3PA portal models, the model owner (or default model users) can always create applications.
    if (companyId === selectedModel || companyId === modelOwner) return true;

    // Otherwise, check if the company has some attacher in their list that is not pending.
    return Object.values(attacherList ?? {}).some((attacher) => !attacher.pending && !attacher.pending_join_company);
  }

  updateAppRowExpanded(jobsRefIndex) {
    const jobRefDisplayPath = `sortedFilteredJobRefs.${jobsRefIndex}.$display`;
    const jobRefDisplay = this.get(jobRefDisplayPath) ?? {};
    const rowExpanded = !!jobRefDisplay.userRowExpanded || jobRefDisplay.filterRowExpanded;

    if (rowExpanded !== jobRefDisplay.rowExpanded) {
      // If row is supposed to be opened, stop hiding collapse content and let the dom-if handler expand the row once content has been stamped.
      if (rowExpanded) this.set(`${jobRefDisplayPath}.showCollapseContent`, true);
      // Otherwise, start collapsing the row and let the collapse's transition end handler hide the content once the row is collapsed.
      else {
        this.set(`${jobRefDisplayPath}.animateExpand`, true);
        this.set(`${jobRefDisplayPath}.rowExpanded`, false);
        // Notify start iron list update loop.
        const ironList = this.shadowRoot?.querySelector('#appList');
        NotifyResizable('poleAppOverview', ironList, 400);
      }
    }
  }

  showAllDrafts() {
    this.showDrafts = true;
  }

  showAllHiddenJobs() {
    this.numJobsToShow = null;
  }

  showCostExport(systemAdmin, appName) {
    return systemAdmin && (appName || '').startsWith('lge-ku');
  }

  showInvoiceExport(userGroup) {
    return (userGroup == 'katapult' || userGroup == 'ppl_attachments') && config.appName == 'ppl-kws';
  }

  showAccrualExport(userGroup, appName) {
    return userGroup == 'katapult' && appName == 'ppl-kws';
  }

  showFilteringSpinner(filteringJobs, waitingForInitialJobData) {
    return filteringJobs && !waitingForInitialJobData;
  }

  toArray(object) {
    return ToArray(object);
  }

  updateFilters(e) {
    const filters = e.detail.value;

    // Update any filters that have changed (cuts down on redundant updates)
    if (filters.searchString !== this.searchString) this.searchString = filters.searchString;
    if (filters.showArchived !== this.showArchived) this.showArchived = filters.showArchived;
    if (filters.showDuplicated !== this.showDuplicated) this.showDuplicated = filters.showDuplicated;
    if (filters.showDrafts !== this.showDrafts) this.showDrafts = filters.showDrafts;
    if (filters.showCompletedApps !== this.showCompletedApps) this.showCompletedApps = filters.showCompletedApps;
    if (!DeepEqual(filters.filterAttributeValues, this.filterAttributeValues)) this.filterAttributeValues = filters.filterAttributeValues;
  }

  savedFilterLoaded(e) {
    const { savedFilter } = e.detail;
    const { visibleWorkflowIds } = savedFilter?.parsedConditions ?? {};
    if (Array.isArray(visibleWorkflowIds)) {
      // Hide all workflows
      this.workflowVisibility.forEach((item) => {
        this.setWorkflowVisibility(item.workflowId, false);
      });

      // Show the workflows that are visible in the saved filter
      visibleWorkflowIds.forEach((workflowId) => {
        this.setWorkflowVisibility(workflowId, true);
      });
      this.updateWorkflowVisibility();
    }
  }

  computeFilterOnAdminStrategy(userGroup, selectedModel, modelOwner, adminStrategy) {
    const userActiveCompanyIsModelOrModelOwner = userGroup === selectedModel || userGroup === modelOwner;
    const hasAdminStrategy = ['REGION', 'ATTACHER', 'REGION_AND_ATTACHER'].includes(adminStrategy);
    return userActiveCompanyIsModelOrModelOwner && hasAdminStrategy;
  }

  async getModelsForSelection() {
    if (!this.companies || !this.userGroup) return;

    // Set up the models to filter, starting with the company's model list and default model
    const modelOptionsIds = this.modelOptions?.map((x) => x.value) ?? [];
    const setOfModelsForFiltering = new Set([...modelOptionsIds, this.userGroup]);

    // Add the server utility models to the list of models if they are allowed by at least one attacher
    const allowedModels = Object.keys(this.serverUtilityModels ?? {}).filter((modelId) =>
      Object.values(this.attacherList ?? {}).some((attacher) => attacher.allowed_utilities?.[modelId])
    );
    allowedModels.forEach((modelId) => setOfModelsForFiltering.add(modelId));

    // If the server utility company is set, add it to the list of models
    if (this.serverUtilityCompany) setOfModelsForFiltering.add(this.serverUtilityCompany);

    const modelsForFiltering = [...setOfModelsForFiltering].map((model) => {
      const label = this.companies[model]?.name ?? model;
      const modelObject = { label, value: model, _default: true };
      // Add the shared icon for models that are shared
      const modelOption = this.modelOptions?.find((x) => x.value === model);
      if (modelOption?.source_shared) modelObject.icons = [{ icon: 'social:share', size: 24 }];
      return modelObject;
    });

    // if there are no models to filter, return early
    if (modelsForFiltering.length == 0) return;

    // get the app types for each model here
    this.modelsForSelectionLoading = true;
    const modelsForSelectionAndNulls = await Parallel.map(
      modelsForFiltering,
      async (model) => {
        const modelKey = model.value;
        if (!modelKey) return null;

        // Models must have at least one app type to be selectable
        const workflowsConfigRef = globalThis.FirebaseWorker.database().ref(`photoheight/company_space/${modelKey}/portal_config`);
        const appTypes = (await workflowsConfigRef.child(`app_types`).once('value')).val();
        if (!appTypes || Object.keys(appTypes).length == 0) return null;

        return model;
      },
      10
    );

    this.modelsForSelection = modelsForSelectionAndNulls.filter((model) => model != null);
    this.modelsForSelectionLoading = false;
  }

  setIs3PAPortalModel(is3PAPortalModel) {
    this.is3PAPortalModel = is3PAPortalModel || (this.serverUtilityCompany != null && this.selectedModel === this.serverUtilityCompany);
  }

  signedInChanged() {
    if (!this.signedIn) {
      this.portalConfig = {};
      this.selectedModel = null;
    }
  }

  userGroupChanged() {
    if (!this.userGroup) return;
    // Only clear the selected model if the user group was changed (don't clear on initial load)
    if (this.userGroupAlreadyLoaded) {
      // clear important data when the user group changes
      localStorage.removeItem('selectedModel');
      this.selectedModel = null;
      this.portalConfig = {};
    } else this.userGroupAlreadyLoaded = true;
  }

  showSingleModelName() {
    if (!this.selectedModel || !this.companies || this.modelsForSelection?.length > 1) return null;
    const modelName = this.companies[this.selectedModel]?.name ?? this.selectedModel;
    return modelName;
  }

  setHideResultsMessage() {
    // Create a lookup of statements to check.  Statements are priority ordered.
    const jobDataStatements = [
      {
        result: !this.modelsForSelectionLoading && (!Array.isArray(this.modelsForSelection) || this.modelsForSelection.length === 0),
        message: 'You do not have access to any workflows'
      },
      {
        result: !this.modelsForSelectionLoading && !this.selectedModel,
        message: 'Please select a model to begin'
      },
      {
        result: !this.waitingForInitialJobData && this.sortedFilteredJobRefs?.length === 0 && this.numHiddenJobs == 0,
        message: 'There are no jobs that match the current filters'
      }
    ];

    // Hide job data and set a message if there is a false statement
    const blockingStatement = jobDataStatements.find((statement) => statement.result === true);
    this.hideResultsMessage = blockingStatement != null ? blockingStatement.message : null;
  }

  _updateModelListeners(selectedModel, signedIn) {
    this._unsubscribeModelOwner?.();
    this._unsubscribeCompanyAttributes?.();
    this._unsubscribeAttachmentTypes?.();
    if (!selectedModel || !signedIn) {
      this.modelOwner = null;
      this.companyAttributes = null;
      this.attachmentTypes = null;
      return;
    }
    const model = KatapultModel.fromId(selectedModel);
    this._unsubscribeModelOwner = model.onModelOwnerSnapshot((snapshot) => {
      this.modelOwner = snapshot.val() ?? selectedModel;
    });
    this._unsubscribeCompanyAttributes = model.onAttributesSnapshot((snapshot) => {
      this.companyAttributes = snapshot.val();
    });
    this._unsubscribeAttachmentTypes = model.onModelPathSnapshot('models/attributes/attachment_type/picklists/default', (snapshot) => {
      this.attachmentTypes = snapshot.val();
    });
  }

  _getColumnLabel(name) {
    return getColumnLabel(name, { overviewAttributes: this.filteredOverviewAttributes, attributeModels: this.companyAttributes });
  }

  setHoveredAttributeHeader(event) {
    this.hoveredAttributeHeader = event.model?.overviewAttribute?.attribute;
  }

  clearHoveredAttributeHeader() {
    this.hoveredAttributeHeader = null;
  }

  showHoverFilterIcon(sortAttr, attribute) {
    const attributeIsHovered = this.hoveredAttributeHeader === attribute;
    return sortAttr !== attribute && attributeIsHovered;
  }

  getCreateButtonTooltipText() {
    if (!this.selectedModel) return 'No model selected';

    const termForJob = this.is3PAPortalModel ? 'application' : 'job';
    const createAppDisabled = !(this.userCanWrite || this.userIsAppManager);
    if (createAppDisabled) return `You must have the Application Manager role (or be a Write user) to create a new ${termForJob}.`;

    return `Create a new ${termForJob}`;
  }

  computeCreateButtonDisabled(userCanWrite, userIsAppManager, selectedModel) {
    return !(userCanWrite || userIsAppManager) || !selectedModel;
  }
}

window.customElements.define(PoleApplicationOverview.is, PoleApplicationOverview);
